// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard.css */

/* ─── Page ─────────────────────────────────────────────── */
.dash-page {
  padding: 32px 40px;
  font-family: 'Segoe UI', 'Inter', sans-serif;
  color: #0f172a;
  min-height: 100vh;
  background: #f1f5f9;
}

/* ─── Top bar ───────────────────────────────────────────── */
.dash-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.dash-greeting {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 4px;
}

.dash-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

/* Role badge in top bar */
.dash-role-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.dash-role-badge i { font-size: 13px; }

.badge-danger  { background: rgba(231,76,60,0.10);  color: #c0392b; border: 1px solid rgba(231,76,60,0.25); }
.badge-info    { background: rgba(52,152,219,0.10); color: #1a7abf; border: 1px solid rgba(52,152,219,0.25); }
.badge-success { background: rgba(39,174,96,0.10);  color: #1e8449; border: 1px solid rgba(39,174,96,0.25); }

/* ─── Divider ───────────────────────────────────────────── */
.dash-divider {
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 0 0 24px;
}

/* ─── Stats grid ────────────────────────────────────────── */
.dash-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}

.dash-stat-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 16px 18px;
}

.dash-stat-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.dash-stat-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}

.dash-stat-trend {
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 3px;
}
.dash-stat-trend.up { color: #1e8449; }
.dash-stat-trend i  { font-size: 12px; }

.dash-stat-val {
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1;
}
.dash-stat-unit { font-size: 14px; font-weight: 400; color: #64748b; }

.dash-stat-lbl {
  font-size: 12px;
  color: #64748b;
  margin-top: 4px;
}

/* ─── Icon color helpers ────────────────────────────────── */
.icon-info      { background: rgba(52,152,219,0.12); color: #1a7abf; }
.icon-success   { background: rgba(39,174,96,0.12);  color: #1e8449; }
.icon-warning   { background: rgba(243,156,18,0.12); color: #b7770d; }
.icon-danger    { background: rgba(231,76,60,0.12);  color: #c0392b; }
.icon-secondary { background: #f1f5f9;               color: #475569; }

.color-info      { color: #1a7abf; }
.color-success   { color: #1e8449; }
.color-warning   { color: #b7770d; }
.color-danger    { color: #c0392b; }
.color-secondary { color: #475569; }

/* ─── Body layout ───────────────────────────────────────── */
.dash-body {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 16px;
  align-items: start;
}

.dash-col-left,
.dash-col-right {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ─── Panel ─────────────────────────────────────────────── */
.dash-panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 20px 22px;
}

.dash-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.dash-panel-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 14px;
}

.dash-view-all {
  font-size: 12px;
  font-weight: 600;
  color: #1a7abf;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

/* ─── Quick actions ─────────────────────────────────────── */
.dash-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
}
.dash-quick-actions { margin-bottom: 4px; }

.dash-action-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  cursor: pointer;
  transition: background 0.15s;
  text-align: left;
}
.dash-action-btn:hover { background: #f1f5f9; }

.dash-action-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.dash-action-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}
.dash-action-sub {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  margin-top: 1px;
}

/* ─── Recent projects ───────────────────────────────────── */
.dash-proj-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 0;
  border-bottom: 1px solid #f1f5f9;
}
.dash-proj-row:last-child { border-bottom: none; padding-bottom: 0; }

.dash-proj-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  flex-shrink: 0;
}

.dash-proj-name {
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dash-proj-bar-wrap {
  width: 72px;
  height: 5px;
  border-radius: 3px;
  background: #e2e8f0;
  flex-shrink: 0;
}
.dash-proj-bar { height: 5px; border-radius: 3px; }

.dash-proj-pct {
  font-size: 12px;
  color: #64748b;
  min-width: 30px;
  text-align: right;
  flex-shrink: 0;
}

.dash-status-pill {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 9px;
  border-radius: 10px;
  flex-shrink: 0;
}
.pill-run  { background: rgba(52,152,219,0.10);  color: #1a7abf; }
.pill-done { background: rgba(39,174,96,0.10);   color: #1e8449; }
.pill-wait { background: rgba(243,156,18,0.12);  color: #b7770d; }

/* ─── Activity feed ─────────────────────────────────────── */
.dash-feed-item {
  display: flex;
  gap: 12px;
  padding: 9px 0;
  border-bottom: 1px solid #f1f5f9;
}
.dash-feed-item:last-child { border-bottom: none; padding-bottom: 0; }

.dash-feed-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 4px;
}
.dot-run  { background: #378ADD; }
.dot-done { background: #27ae60; }
.dot-warn { background: #f39c12; }

.dash-feed-text {
  font-size: 13px;
  color: #334155;
  line-height: 1.45;
}
.dash-feed-time {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

/* ─── Role card ─────────────────────────────────────────── */
.dash-role-header {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 14px;
}

.dash-role-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  flex-shrink: 0;
}

.dash-role-name {
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 2px;
}
.dash-role-desc {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
  margin: 0;
}

.dash-cap-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.dash-cap-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #334155;
}
.dash-cap-check { font-size: 14px; flex-shrink: 0; }

/* ─── Responsive ────────────────────────────────────────── */
@media (max-width: 900px) {
  .dash-stats-grid { grid-template-columns: repeat(2, 1fr); }
  .dash-body { grid-template-columns: 1fr; }
}
@media (max-width: 560px) {
  .dash-page { padding: 20px 16px; }
  .dash-stats-grid { grid-template-columns: 1fr 1fr; }
  .dash-actions-grid { grid-template-columns: 1fr; }
}

/* ══════════════════════════════════════════════════════════════════════
 * DASHBOARD REDESIGN ADDITIONS (v2 — landing-page look, fixed-height cards)
 * Everything below is new; nothing above this line was changed, so any
 * other page still importing dash-* classes keeps working as-is.
 *
 * Palette is taken from the KinetiQ landing page (kinetiq.vidyayug.com):
 * deep navy hero, teal accent, soft white cards.
 * ══════════════════════════════════════════════════════════════════════ */

.dash-page {
  --kq-navy:      #0b1f4a;
  --kq-navy-2:    #12306b;
  --kq-teal:      #14c8b0;
  --kq-teal-dark: #0e8fa8;
  --kq-ink:       #0f172a;
  --kq-muted:     #64748b;
  --kq-line:      #e2e8f0;
  --kq-card-h:    296px;   /* trimmed from 320px to cut page scroll, kept enough headroom for the Performance card's three stacked blocks */
  background: #f1f5f9;
  padding: 20px 32px 32px;
}

/* ─── Hero banner ───────────────────────────────────────── */
.dash-hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  padding: 16px 26px;
  margin-bottom: 14px;
  border-radius: 16px;
  color: #ffffff;
  background:
    radial-gradient(520px 200px at 88% -10%, rgba(20,200,176,0.30), transparent 65%),
    linear-gradient(120deg, var(--kq-navy) 0%, var(--kq-navy-2) 62%, #0f3d78 100%);
  box-shadow: 0 10px 28px rgba(11,31,74,0.18);
}

.dash-hero-main { min-width: 0; }

.dash-hero-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid rgba(20,200,176,0.45);
  background: rgba(20,200,176,0.10);
  color: var(--kq-teal);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.10em;
  text-transform: uppercase;
}

.dash-hero-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--kq-teal);
}

.dash-hero-title {
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.01em;
  margin: 8px 0 4px;
  color: #ffffff;
}
.dash-hero-title em { font-style: normal; color: var(--kq-teal); }

.dash-hero-sub {
  font-size: 13px;
  color: rgba(255,255,255,0.72);
  margin: 0 0 12px;
}

.dash-hero-actions { display: flex; gap: 10px; flex-wrap: wrap; }

.dash-hero-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
  transition: transform 0.12s, background 0.15s;
}
.dash-hero-btn:hover { transform: translateY(-1px); }
.dash-hero-btn--primary { background: var(--kq-teal-dark); color: #ffffff; }
.dash-hero-btn--primary:hover { background: #0b7d94; }
.dash-hero-btn--ghost {
  background: rgba(255,255,255,0.08);
  border-color: rgba(255,255,255,0.25);
  color: #ffffff;
}
.dash-hero-btn--ghost:hover { background: rgba(255,255,255,0.15); }

.dash-hero-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

.dash-hero-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 13px;
  border-radius: 20px;
  background: rgba(255,255,255,0.10);
  border: 1px solid rgba(255,255,255,0.18);
  font-size: 12px;
  font-weight: 600;
  color: #e6eefb;
}
.dash-hero-chip i { color: var(--kq-teal); font-size: 14px; }

@media (max-width: 900px) {
  .dash-hero { flex-direction: column; align-items: flex-start; }
  .dash-hero-side { flex-direction: row; flex-wrap: wrap; align-items: flex-start; }
}

/* ─── Getting Started checklist ─────────────────────────── */
.dash-checklist-card {
  background: #ffffff;
  border: 1px solid var(--kq-line);
  border-radius: 14px;
  padding: 14px 22px 12px;
  margin-bottom: 14px;
  box-shadow: 0 1px 2px rgba(15,23,42,0.04);
}

.dash-checklist-title {
  font-size: 14px;
  font-weight: 800;
  color: var(--kq-navy);
  margin: 0 0 10px;
}

.dash-checklist-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  align-items: start;
}

.dash-step-head { display: flex; align-items: flex-start; gap: 10px; }

.dash-step-num {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e2e8f0;
  color: var(--kq-muted);
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dash-step--done .dash-step-num { background: rgba(20,200,176,0.16); color: #0b8f7e; }
.dash-step--current .dash-step-num { background: var(--kq-navy-2); color: #ffffff; }

.dash-step-label { font-size: 14px; font-weight: 700; color: var(--kq-ink); line-height: 24px; }
.dash-step-tag { font-weight: 500; font-size: 12px; color: var(--kq-teal-dark); }

.dash-step-pending {
  display: inline-block;
  margin-left: 8px;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 1px 8px;
  vertical-align: middle;
}

.dash-step-desc { font-size: 12px; color: var(--kq-muted); line-height: 1.5; margin: 6px 0 0 34px; }
.dash-step-desc--muted { opacity: 0.85; }
.dash-step-body { margin-top: 8px; }

.dash-step-cta {
  margin-left: 34px;
  background: var(--kq-teal-dark);
  color: #ffffff;
  border: none;
  border-radius: 9px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.dash-step-cta:hover { background: #0b7d94; }

.dash-progress-row { display: flex; align-items: center; gap: 12px; margin-top: 16px; }
.dash-progress-track { flex: 1 1; height: 6px; border-radius: 3px; background: #e2e8f0; overflow: hidden; }
.dash-progress-fill {
  height: 100%;
  border-radius: 3px;
  background: linear-gradient(90deg, var(--kq-teal-dark), var(--kq-teal));
  transition: width 0.3s ease;
}
.dash-progress-label { font-size: 12px; color: var(--kq-muted); font-weight: 700; flex-shrink: 0; }

@media (max-width: 900px) {
  .dash-checklist-steps { grid-template-columns: 1fr; gap: 16px; }
}

/* ─── Three summary cards ───────────────────────────────── */
.dash-summary-grid {
  display: grid;
  grid-template-columns: repeat(var(--dash-cols, 3), minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 14px;
  align-items: stretch;
}

.dash-summary-card {
  position: relative;
  background: #ffffff;
  border: 1px solid var(--kq-line);
  border-radius: 14px;
  padding: 18px 18px 14px;
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-shadow: 0 1px 2px rgba(15,23,42,0.04);
}

/* Empty state — dashed card, centered icon/copy/CTA (per mockup) */
.dash-summary-card--empty {
  min-height: 230px;
  border: 1.5px dashed #cbd5e1;
  background: rgba(255,255,255,0.6);
  box-shadow: none;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
}

.dash-summary-icon { font-size: 40px; color: #94a3b8; }
.dash-summary-text { font-size: 13px; color: var(--kq-muted); line-height: 1.5; max-width: 240px; }

.dash-summary-cta {
  background: var(--kq-teal-dark);
  color: #ffffff;
  border: none;
  border-radius: 9px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.dash-summary-cta:hover { background: #0b7d94; }
.dash-summary-error { font-size: 11px; color: #c0392b; margin-top: 8px; }

/* Populated state — fixed height so all three cards line up, no gaps */
.dash-summary-card--data {
  height: var(--kq-card-h);
  border-top: 3px solid var(--kq-teal);
  overflow: hidden;
}

.dash-summary-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.dash-summary-card-title {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--kq-navy-2);
  margin: 0;
}
.dash-summary-card-title i { color: var(--kq-teal-dark); font-size: 15px; }

.dash-count {
  min-width: 22px;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: var(--kq-teal-dark);
  background: rgba(14,143,168,0.10);
  border-radius: 10px;
  padding: 2px 8px;
}

/* The scroll area — thin scrollbar, bottom fade hints there's more */
.dash-card-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.dash-card-scroll::-webkit-scrollbar { width: 6px; }
.dash-card-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
.dash-card-scroll::-webkit-scrollbar-track { background: transparent; }

.dash-summary-card--scroll::after {
  content: '';
  position: absolute;
  left: 0; right: 0; bottom: 0;
  height: 26px;
  background: linear-gradient(to bottom, rgba(255,255,255,0), #ffffff);
  border-radius: 0 0 14px 14px;
  pointer-events: none;
}

/* Card 1 — activity rows */
.dash-feed-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 4px;
  border-bottom: 1px solid #f1f5f9;
}
.dash-feed-row:last-child { border-bottom: none; margin-bottom: 18px; }
.dash-feed-row .dash-feed-dot { margin-top: 0; }
.dash-feed-main { flex: 1 1; min-width: 0; }
.dash-feed-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--kq-ink);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dash-feed-when { font-size: 11px; color: #94a3b8; margin: 2px 0 0; }

.dash-example-tag {
  display: inline-block;
  margin-left: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #b7770d;
  background: rgba(243,156,18,0.14);
  border-radius: 8px;
  padding: 1px 7px;
  vertical-align: middle;
}

/* Card 2 — performance (fills the whole card) */
.dash-perf {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 4px;
}

.dash-metric-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.dash-metric {
  text-align: center;
  padding: 12px 4px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}
.dash-metric-val { font-size: 24px; font-weight: 800; color: var(--kq-navy); margin: 0; line-height: 1.1; }
.dash-metric-val--good { color: #0b8f7e; }
.dash-metric-val--muted { color: #94a3b8; font-size: 18px; }
.dash-metric-lbl { font-size: 11px; color: var(--kq-muted); margin: 4px 0 0; }

.dash-perf-block { display: flex; flex-direction: column; gap: 6px; }
.dash-perf-label {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 700;
  color: var(--kq-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.dash-stack {
  display: flex;
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
  background: #e2e8f0;
}
.dash-stack-seg { height: 100%; }
.seg-ok   { background: var(--kq-teal); }
.seg-warn { background: #f5a524; }
.seg-bad  { background: #e5534b; }

.dash-legend { display: flex; flex-wrap: wrap; gap: 4px 14px; font-size: 11px; color: var(--kq-muted); }
.dash-legend span { display: inline-flex; align-items: center; gap: 5px; }
.dash-legend-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; }

.dash-meter { height: 8px; border-radius: 4px; background: #e2e8f0; overflow: hidden; }
.dash-meter-fill {
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--kq-navy-2), var(--kq-teal-dark));
}

/* Card 3 — folder rows */
.dash-folder-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 6px;
  border: none;
  background: none;
  border-radius: 9px;
  cursor: pointer;
  text-align: left;
  width: 100%;
}
.dash-folder-row:hover { background: #f1f7fb; }
.dash-folder-row--open { background: rgba(20,200,176,0.10); }
.dash-folder-row:last-child { margin-bottom: 18px; }

.dash-folder-iconbox {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(14,143,168,0.10);
  color: var(--kq-teal-dark);
  font-size: 15px;
}

.dash-folder-name {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--kq-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dash-folder-meta { font-size: 11px; color: #94a3b8; flex-shrink: 0; }
.dash-folder-chevron { color: #94a3b8; font-size: 12px; flex-shrink: 0; }

.dash-summary-card .dash-view-all { color: var(--kq-teal-dark); }

@media (max-width: 1100px) {
  .dash-summary-grid { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 720px) {
  .dash-summary-grid { grid-template-columns: 1fr; }
  .dash-page { padding: 18px 14px 32px; --kq-card-h: 300px; }
}

/* ─── Run summary panel ─────────────────────────────────── */
.dash-run-summary {
  background: #ffffff;
  border: 1px solid var(--kq-line);
  border-left: 3px solid var(--kq-teal);
  border-radius: 14px;
  padding: 16px 22px;
  margin-bottom: 18px;
}

.dash-run-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px 24px;
  font-size: 13px;
  color: var(--kq-ink);
  font-weight: 600;
}
.dash-run-summary-notes { grid-column: 1 / -1; }

.dash-td-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 2px;
}
.dash-run-summary-actions { margin-top: 12px; }

@media (max-width: 900px) { .dash-run-summary-grid { grid-template-columns: 1fr 1fr; } }
@media (max-width: 560px) { .dash-run-summary-grid { grid-template-columns: 1fr; } }

/* ─── Lower panels pick up the same card polish ─────────── */
.dash-panel { box-shadow: 0 1px 2px rgba(15,23,42,0.04); }
.dash-panel-title { color: var(--kq-navy-2); }
.dash-view-all { color: var(--kq-teal-dark); }
.dash-action-btn:hover { background: #f1f7fb; border-color: rgba(14,143,168,0.35); }

/* ─── Overview bar + "Customize" cards menu (item #22) ─────── */
.dash-section-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 2px 8px;
}
.dash-section-title {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--kq-muted);
}
.dash-customize { position: relative; }
.dash-customize .dash-view-all { display: inline-flex; align-items: center; gap: 6px; }
.dash-customize-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 20;
  min-width: 220px;
  padding: 8px;
  background: #ffffff;
  border: 1px solid var(--kq-line);
  border-radius: 10px;
  box-shadow: 0 10px 24px rgba(15,23,42,0.14);
}
.dash-customize-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  border-radius: 7px;
  font-size: 13px;
  color: var(--kq-ink);
  cursor: pointer;
}
.dash-customize-item:hover { background: #f1f7fb; }

/* ─── Setup modal (checklist step 1) ───────────────────────── */
.dash-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(11,31,74,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.dash-modal {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 14px;
  padding: 22px 24px;
  box-shadow: 0 20px 48px rgba(11,31,74,0.30);
}
.dash-modal-title { font-size: 16px; font-weight: 800; color: var(--kq-navy); margin: 0 0 6px; }
.dash-modal-text { font-size: 12px; color: var(--kq-muted); line-height: 1.5; margin: 0 0 14px; }
.dash-modal-label { display: block; font-size: 11px; font-weight: 700; color: var(--kq-muted); text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px; }
.dash-modal-input {
  width: 100%;
  box-sizing: border-box;
  padding: 9px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  font-size: 14px;
  color: var(--kq-ink);
}
.dash-modal-input:focus { outline: none; border-color: var(--kq-teal-dark); box-shadow: 0 0 0 3px rgba(14,143,168,0.15); }
.dash-modal-actions { display: flex; justify-content: flex-end; align-items: center; gap: 14px; margin-top: 18px; }

/* ─── Run History page (/run-history) ────────────────────────
 * Rewritten for readability + less scrolling:
 *   - rows use CSS Grid (fixed columns) instead of flex, so name/model/R²/
 *     date/status/actions always line up and never run together
 *   - each reaction-system group is a collapsible <button> header, closed
 *     by default except the first, so 4 systems worth of history doesn't
 *     dump every row on screen at once
 *   - a group with many runs shows 5 at a time with "Show N more"
 *   - action buttons are compact icon buttons with a visible hit target,
 *     not bare text jammed next to each other
 */

.rh-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 12px;
}
.rh-head .dash-view-all { display: inline-flex; align-items: center; gap: 6px; margin-bottom: 6px; }
.rh-title { font-size: 22px; font-weight: 800; color: var(--kq-navy); margin: 0; }
.rh-sub { font-size: 13px; color: var(--kq-muted); margin: 3px 0 0; }
.rh-btn { font-size: 13px; }

/* Sticky so filtering/searching doesn't require scrolling back to the top */
.rh-toolbar {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 0;
  margin-bottom: 4px;
  background: #f1f5f9;
}
.rh-filters { display: inline-flex; padding: 3px; background: #e8eef5; border-radius: 10px; gap: 2px; }
.rh-filter {
  border: none;
  background: transparent;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  color: var(--kq-muted);
  cursor: pointer;
}
.rh-filter--on { background: #ffffff; color: var(--kq-navy-2); box-shadow: 0 1px 2px rgba(15,23,42,0.10); }
.rh-search {
  min-width: 220px;
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  font-size: 13px;
  background: #ffffff;
}
.rh-search:focus { outline: none; border-color: var(--kq-teal-dark); }
.rh-note {
  font-size: 12px;
  color: #b7770d;
  background: rgba(243,156,18,0.10);
  border-radius: 8px;
  padding: 7px 12px;
  margin: 0 0 10px;
}

/* One column definition shared by the header row and every data row, so
   everything stays aligned: checkbox | name | model | R² | date | status | actions */
.rh-group { margin-bottom: 10px; background: #ffffff; border: 1px solid var(--kq-line); border-radius: 12px; overflow: hidden; }

.rh-group-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 12px 16px;
  background: #ffffff;
  border: none;
  cursor: pointer;
  text-align: left;
}
.rh-group-header:hover { background: #f8fafc; }
.rh-group-caret {
  font-size: 13px;
  color: #94a3b8;
  transition: transform 0.15s ease;
  flex-shrink: 0;
}
.rh-group-caret--open { transform: rotate(90deg); }
.rh-group-icon { color: var(--kq-teal-dark); font-size: 15px; flex-shrink: 0; }
.rh-group-name {
  flex: 1 1;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--kq-navy-2);
}

.rh-group-body { border-top: 1px solid var(--kq-line); padding: 4px 10px 10px; }

.rh-row {
  display: grid;
  grid-template-columns: 22px minmax(0, 1.6fr) 1fr 0.7fr 1.1fr 0.9fr auto;
  align-items: center;
  column-gap: 12px;
  padding: 9px 6px;
}
.rh-row-wrap + .rh-row-wrap .rh-row,
.rh-row-wrap:not(:last-child) .rh-row { border-bottom: 1px solid #f1f5f9; }

.rh-row--head {
  padding: 4px 6px 8px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
  border-bottom: 1px solid var(--kq-line);
}

.rh-name {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--kq-ink);
}
.rh-name-text { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.rh-tag { flex-shrink: 0; }

.rh-meta { font-size: 12.5px; color: var(--kq-muted); white-space: nowrap; }
.rh-dim { color: #b3bcc9; }
.rh-r2 { font-variant-numeric: tabular-nums; color: var(--kq-ink); font-weight: 600; }
.rh-date { color: #94a3b8; }

.rh-actions { display: inline-flex; gap: 4px; justify-self: end; }
.rh-action {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 7px;
  color: var(--kq-muted);
  font-size: 14px;
  cursor: pointer;
}
.rh-action:hover { background: #f1f7fb; border-color: rgba(14,143,168,0.25); color: var(--kq-teal-dark); }
.rh-action--danger:hover { background: rgba(192,57,43,0.08); border-color: rgba(192,57,43,0.25); color: #c0392b; }

.rh-more {
  width: 100%;
  margin-top: 4px;
  padding: 8px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: transparent;
  color: var(--kq-teal-dark);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.rh-more:hover { background: #f1f7fb; }

.rh-summary {
  margin: 2px 0 8px;
  padding: 12px 16px;
  background: #f8fafc;
  border-left: 3px solid var(--kq-teal);
  border-radius: 8px;
}
.rh-summary .dash-panel-title { margin-bottom: 10px; }

@media (max-width: 900px) {
  .rh-row { grid-template-columns: 20px minmax(0, 1fr) auto; row-gap: 4px; }
  .rh-row--head { display: none; }   /* column header doesn't make sense once columns collapse */
  .rh-meta.rh-r2, .rh-meta.rh-date { grid-column: 2; }
  .rh-actions { grid-column: 3; grid-row: 1 / span 2; align-self: start; }
}

.rh-head-actions { display: flex; gap: 10px; }

/* ─── Systems page (/systems) — reuses Run History's row/grid classes ─── */
.sys-rename-input { width: 100%; padding: 5px 9px; font-size: 13px; }

/* ══════════════════════════════════════════════════════════════════════
 * REVISION — client items #2, #3, #4, #5  (compact layout + DARK THEME)
 * Appended last so it wins over everything above. The dark tokens mirror
 * DataFittingPage.css ("Dark theme (default)"); fallbacks are included so
 * this file also works if that stylesheet isn't loaded yet.
 *
 * Branding note (#5 "ask before changing any branding element"): this block
 * only recolors the dashboard surfaces to the existing Data Fitting palette.
 * Logo, product name and the top Navbar are untouched.
 * ══════════════════════════════════════════════════════════════════════ */

.dash-page {
  --kq-bg:        var(--color-bg, #0B1826);
  --kq-card:      var(--color-card, #12253D);
  --kq-surface:   var(--color-surface, #0F2135);
  --kq-panel:     var(--color-panel, #142A44);
  --kq-accent:    var(--color-accent, #00C2A8);
  --kq-accent-h:  var(--color-accent-hover, #00A88F);
  --kq-on-accent: #062a33;

  --kq-ink:       var(--color-text, #F0F7FA);
  --kq-muted:     var(--color-text-muted, #93A9BC);
  --kq-line:      var(--color-border, #1F3350);
  --kq-navy:      var(--color-text, #F0F7FA);        /* titles were navy-on-white */
  --kq-navy-2:    var(--color-text-mid, #B9CBD8);
  --kq-teal:      var(--kq-accent);
  --kq-teal-dark: var(--kq-accent);                  /* links/icons: bright accent on dark */
  --kq-card-h:    236px;                             /* #2: was 296px */

  background: var(--kq-bg);
  color: var(--kq-ink);
  padding: 16px 28px 28px;
  font-family: var(--font-ui, 'Inter', 'Segoe UI', sans-serif);
  min-height: 100%;
}

/* ─── #2 Compact welcome banner ─────────────────────────── */
.dash-hero {
  padding: 12px 20px;
  margin-bottom: 12px;
  border-radius: 12px;
  background: linear-gradient(120deg, #0F2135 0%, #142A44 100%);
  border: 1px solid var(--kq-line);
  border-left: 3px solid var(--kq-accent);
  box-shadow: none;
}
.dash-hero-title { font-size: 17px; font-weight: 700; margin: 0; letter-spacing: 0; color: var(--kq-ink); }
.dash-hero-title em { font-style: normal; font-weight: 500; color: var(--kq-muted); }
.dash-hero-side { flex-direction: row; align-items: center; gap: 8px; }
.dash-hero-chip {
  font-family: inherit;
  cursor: pointer;
  background: rgba(255,255,255,0.05);
  border: 1px solid var(--kq-line);
  color: var(--kq-ink);
  transition: border-color .15s, background .15s;
}
.dash-hero-chip:hover { border-color: var(--kq-accent); background: rgba(0,194,168,0.10); }
.dash-hero-chip i { color: var(--kq-accent); }
@media (max-width: 900px) { .dash-hero { flex-direction: column; align-items: flex-start; } }

/* ─── #3 / #4 Getting started: every step is a link ─────── */
.dash-checklist-card {
  background: var(--kq-card);
  border: 1px solid var(--kq-line);
  padding: 12px 16px 12px;
  margin-bottom: 12px;
  box-shadow: none;
}
.dash-checklist-head { display: flex; justify-content: space-between; align-items: baseline; gap: 12px; margin-bottom: 10px; }
.dash-checklist-title { margin: 0; font-size: 14px; font-weight: 700; color: var(--kq-ink); }
.dash-checklist-steps { gap: 10px; }

.dash-step-link {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  text-align: left;
  font-family: inherit;
  color: var(--kq-ink);
  background: transparent;
  border: 1px solid var(--kq-line);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color .15s, background .15s;
}
.dash-step-link:hover { border-color: var(--kq-accent); background: rgba(0,194,168,0.07); }
.dash-step-link:focus-visible { outline: 2px solid var(--kq-accent); outline-offset: 2px; }
.dash-step--current { border-color: rgba(0,194,168,0.55); background: rgba(0,194,168,0.07); }
.dash-step-text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.dash-step-link .dash-step-label { display: block; font-size: 13.5px; font-weight: 700; line-height: 22px; color: var(--kq-ink); text-decoration: underline; text-decoration-color: rgba(147,169,188,0.45); text-underline-offset: 3px; }
.dash-step-link:hover .dash-step-label { text-decoration-color: var(--kq-accent); }
.dash-step-link .dash-step-desc { display: block; margin: 0; font-size: 12px; color: var(--kq-muted); line-height: 1.4; }
.dash-step-tag { margin-left: 8px; padding: 1px 8px; border-radius: 10px; font-size: 10.5px; font-weight: 700; text-decoration: none; color: var(--kq-on-accent); background: var(--kq-accent); display: inline-block; line-height: 16px; }

.dash-step-num { background: var(--color-border-light, #2A415F); color: var(--kq-ink); }
.dash-step--done .dash-step-num { background: var(--kq-accent); color: var(--kq-on-accent); }
.dash-step--current .dash-step-num { background: var(--kq-accent); color: var(--kq-on-accent); }

.dash-progress-track { height: 5px; margin-top: 12px; border-radius: 3px; background: var(--kq-line); overflow: hidden; }
.dash-progress-fill { background: var(--kq-accent); }
.dash-progress-label { font-size: 12px; font-weight: 600; color: var(--kq-muted); }

/* ─── Overview bar with the single run button (#4) ──────── */
.dash-section-bar { margin: 0 0 8px; }
.dash-section-title { color: var(--kq-muted); }
.dash-section-actions { display: flex; align-items: center; gap: 14px; }
.dash-run-btn { display: inline-flex; align-items: center; gap: 7px; }

.dash-summary-cta,
.dash-hero-btn--primary {
  background: var(--kq-accent);
  color: var(--kq-on-accent);
  font-family: inherit;
}
.dash-summary-cta:hover,
.dash-hero-btn--primary:hover { background: var(--kq-accent-h); }
.dash-summary-cta:disabled { opacity: .45; cursor: not-allowed; }
.dash-summary-cta:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }

.dash-view-all,
.dash-summary-card .dash-view-all { color: var(--kq-accent); font-family: inherit; }
.dash-view-all:hover { text-decoration: underline; }

/* ─── Cards ─────────────────────────────────────────────── */
.dash-summary-grid { gap: 12px; margin-bottom: 12px; }
.dash-summary-card {
  background: var(--kq-card);
  border: 1px solid var(--kq-line);
  box-shadow: none;
  padding: 14px 16px 12px;
}
.dash-summary-card--data { border-top: 2px solid var(--kq-accent); }
.dash-summary-card--empty { background: rgba(18,37,61,0.55); border: 1.5px dashed var(--color-border-light, #2A415F); }
.dash-first-card { min-height: 0; flex-direction: row; padding: 22px 24px; gap: 16px; justify-content: flex-start; text-align: left; }
.dash-first-card .dash-summary-icon { font-size: 28px; color: var(--kq-accent); }
.dash-first-card .dash-summary-text { max-width: none; margin: 0; }
.dash-summary-icon { color: var(--kq-muted); }
.dash-summary-text { color: var(--kq-muted); }
.dash-summary-text strong { color: var(--kq-ink); }
.dash-summary-error { color: #f2555a; }
.dash-summary-card-header { margin-bottom: 8px; }

.dash-summary-card--scroll::after { background: linear-gradient(to bottom, rgba(18,37,61,0), var(--kq-card)); }

/* card titles are links now */
.dash-summary-card-title { color: var(--kq-ink); letter-spacing: 0.05em; }
.dash-title-link { background: none; border: none; padding: 0; cursor: pointer; font-family: inherit; text-align: left; }
.dash-title-link:hover { color: var(--kq-accent); }
.dash-title-link:focus-visible { outline: 2px solid var(--kq-accent); outline-offset: 3px; border-radius: 4px; }
.dash-count { color: var(--kq-accent); background: rgba(0,194,168,0.14); }

.dash-card-scroll { scrollbar-color: #2A415F transparent; }
.dash-card-scroll::-webkit-scrollbar-thumb { background: #2A415F; }

/* activity rows are buttons */
.dash-feed-row { border-bottom-color: var(--kq-line); }
.dash-feed-row--btn {
  width: 100%;
  background: none;
  border-left: none; border-right: none; border-top: none;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  border-radius: 8px;
  color: inherit;
}
.dash-feed-row--btn:hover,
.dash-feed-row--open { background: rgba(0,194,168,0.09); }
.dash-feed-name { display: block; color: var(--kq-ink); }
.dash-feed-when { display: block; color: var(--kq-muted); }
.dash-example-tag { color: #F4A261; background: rgba(244,162,97,0.16); }

/* performance tiles are buttons (compact so the shorter card fits) */
.dash-perf { gap: 8px; }
.dash-metric {
  display: flex; flex-direction: column; align-items: center;
  padding: 8px 4px;
  font-family: inherit;
  cursor: pointer;
  background: var(--kq-surface);
  border: 1px solid var(--kq-line);
  transition: border-color .15s;
}
.dash-metric:hover { border-color: var(--kq-accent); }
.dash-metric-val { display: block; font-size: 20px; color: var(--kq-ink); }
.dash-metric-val--good { color: #2FBE84; }
.dash-metric-val--muted { color: var(--kq-muted); font-size: 16px; }
.dash-metric-lbl { display: block; color: var(--kq-muted); margin: 2px 0 0; }
.dash-perf-label { color: var(--kq-muted); }
.dash-stack, .dash-meter { background: var(--kq-line); }
.seg-ok { background: var(--kq-accent); }
.dash-meter-fill { background: linear-gradient(90deg, #0B8DA6, var(--kq-accent)); }
.dash-legend { color: var(--kq-muted); }

/* folder rows */
.dash-folder-row { color: var(--kq-ink); font-family: inherit; }
.dash-folder-row:hover { background: rgba(0,194,168,0.09); }
.dash-folder-row--open { background: rgba(0,194,168,0.14); }
.dash-folder-iconbox { background: rgba(0,194,168,0.14); color: var(--kq-accent); }
.dash-folder-name { color: var(--kq-ink); }
.dash-folder-meta, .dash-folder-chevron { color: var(--kq-muted); }

/* status pills: readable on dark */
.pill-done { background: rgba(47,190,132,0.16); color: #2FBE84; }
.pill-wait { background: rgba(244,162,97,0.16); color: #F4A261; }
.pill-run  { background: rgba(47,185,217,0.16); color: #2FB9D9; }

/* run summary + panels */
.dash-run-summary,
.dash-panel { background: var(--kq-card); border-color: var(--kq-line); box-shadow: none; }
.dash-run-summary { border-left-color: var(--kq-accent); padding: 12px 18px; margin-bottom: 12px; }
.dash-run-summary-grid { color: var(--kq-ink); }
.dash-td-label, .dash-panel-title { color: var(--kq-muted); }

/* Customize menu */
.dash-customize-menu { background: var(--kq-panel); border-color: var(--kq-line); box-shadow: 0 10px 24px rgba(0,0,0,.45); }
.dash-customize-item { color: var(--kq-ink); }
.dash-customize-item:hover { background: rgba(0,194,168,0.09); }

/* ─── Profile & settings modal ──────────────────────────── */
.dash-modal-backdrop { background: rgba(4,12,22,0.70); }
.dash-modal { background: var(--kq-panel); border: 1px solid var(--kq-line); box-shadow: 0 20px 48px rgba(0,0,0,.55); }
.dash-modal-title { color: var(--kq-ink); }
.dash-modal-text { color: var(--kq-muted); }
.dash-modal-label { color: var(--kq-muted); }
.dash-modal-input { background: var(--color-input-bg, #0D1F32); border-color: var(--color-input-border, #1F3350); color: var(--kq-ink); font-family: inherit; }
.dash-modal-input::placeholder { color: #64768A; }
.dash-modal-input:focus { border-color: var(--kq-accent); box-shadow: 0 0 0 3px rgba(0,194,168,0.18); }
.dash-modal-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 14px; }
.dash-modal-row .dash-modal-label { margin: 0; }
.dash-modal-row--split { margin: 14px 0 0; padding-top: 12px; border-top: 1px solid var(--kq-line); }
.dash-modal-value { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 600; color: var(--kq-ink); }
.dash-modal-value i { color: var(--kq-accent); }
.dash-modal-saved { margin-right: auto; font-size: 12px; font-weight: 600; color: #2FBE84; }

/* ─── Run History + Systems pages share these classes: keep them dark ─── */
.rh-title { color: var(--kq-ink); }
.rh-sub { color: var(--kq-muted); }
.rh-toolbar { background: var(--kq-bg); }
.rh-filters { background: var(--kq-surface); }
.rh-filter { color: var(--kq-muted); font-family: inherit; }
.rh-filter--on { background: var(--kq-panel); color: var(--kq-accent); box-shadow: none; }
.rh-search { background: var(--color-input-bg, #0D1F32); border-color: var(--color-input-border, #1F3350); color: var(--kq-ink); }
.rh-search:focus { border-color: var(--kq-accent); }
.rh-note { color: #F4A261; background: rgba(244,162,97,0.12); }
.rh-group { background: var(--kq-card); border-color: var(--kq-line); }
.rh-group-header { background: var(--kq-card); }
.rh-group-header:hover { background: var(--kq-surface); }
.rh-group-name { color: var(--kq-ink); }
.rh-group-body { border-top-color: var(--kq-line); }
.rh-row--head { color: var(--kq-muted); border-bottom-color: var(--kq-line); }
.rh-row-wrap:not(:last-child) .rh-row { border-bottom-color: var(--kq-line); }
.rh-dim { color: var(--color-text-dim, #64768A); }
.rh-date { color: var(--kq-muted); }
.rh-action { color: var(--kq-muted); }
.rh-action:hover { background: rgba(0,194,168,0.10); border-color: rgba(0,194,168,0.35); color: var(--kq-accent); }
.rh-action--danger:hover { background: rgba(242,85,90,0.14); border-color: rgba(242,85,90,0.4); color: #f2555a; }
.rh-more { border-color: var(--color-border-light, #2A415F); color: var(--kq-accent); font-family: inherit; }
.rh-more:hover { background: rgba(0,194,168,0.09); }
.rh-summary { background: var(--kq-surface); border-left-color: var(--kq-accent); }

@media (max-width: 1100px) { .dash-summary-grid { grid-template-columns: 1fr 1fr; } }
@media (max-width: 720px) {
  .dash-summary-grid { grid-template-columns: 1fr; }
  .dash-page { padding: 14px 12px 28px; --kq-card-h: 280px; }
  .dash-checklist-head { flex-direction: column; gap: 2px; }
}
@media (prefers-reduced-motion: reduce) {
  .dash-step-link, .dash-metric, .dash-hero-chip { transition: none; }
}


/* Performance tiles: two tiles now that Avg. R² is gone */
.dash-metric-grid { grid-template-columns: repeat(2, 1fr); }


/* First-time view: three placeholder cards (client reference layout) */
.dash-first-grid { margin-bottom: 12px; }
.dash-first-card { flex-direction: column; justify-content: center; align-items: center; text-align: center; min-height: 190px; padding: 22px 20px; gap: 12px; }
.dash-first-icon { font-size: 40px; color: var(--kq-accent); opacity: .85; }
.dash-first-card .dash-summary-text { max-width: 280px; text-align: center; }
.dash-step-pending { margin-left: 8px; padding: 1px 8px; border-radius: 10px; font-size: 10.5px; font-weight: 600; line-height: 16px; display: inline-block; text-decoration: none; color: var(--kq-muted); background: rgba(147,169,188,0.16); }

/* ════════════════════════════════════════════════════════════════════════
   Reports page (/run-history) — row alignment, bigger action icons, and the
   compact report panel (FitReport.jsx).  Appended last so it wins over the
   earlier .rh-* rules; colours use the --kq-* tokens so it follows the
   light / dark theme automatically.
   ════════════════════════════════════════════════════════════════════════ */

/* ── 1. Row + header columns line up ────────────────────────────────────
   Every .rh-row is its own grid, so an \`auto\` last track gave the header
   row and each data row DIFFERENT widths for the fr columns (Model / R² /
   Date / Status drifted). The Actions track is now a fixed width, which
   makes every row's columns identical.
   5 icons x 36px + 4 gaps x 6px = 204px  ->  208px.                    */
@media (min-width: 901px) {
  .rh-row {
    grid-template-columns: 22px minmax(0, 1.6fr) 1fr 0.7fr 1.1fr 0.9fr 208px;
  }
}
.rh-row--head > span { text-align: left; }
.rh-row--head > span:last-child { text-align: right; }
.rh-row .dash-status-pill { justify-self: start; }   /* pill hugs its text, not the column */

/* ── 2. Bigger Actions icons ────────────────────────────────────────── */
.rh-actions { gap: 6px; }
.rh-action {
  width: 36px;
  height: 36px;
  font-size: 19px;
  border-radius: 9px;
  background: rgba(127, 147, 168, 0.10);
}
.rh-action:disabled { opacity: 0.5; cursor: progress; }

/* ── 3. Report panel: compact two-column layout, Downloads on the right ─ */
.rh-summary { padding: 10px 14px; }

.fr-report { display: flex; flex-direction: column; gap: 10px; }

.fr-head {
  display: flex;
  justify-content: space-between;     /* title left, downloads right */
  align-items: flex-start;
  gap: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--kq-line);
}
.fr-title { margin: 0; font-size: 15px; font-weight: 700; color: var(--kq-ink); }
.fr-sub   { margin: 2px 0 0; font-size: 12px; color: var(--kq-muted); }

.fr-downloads { display: flex; gap: 8px; flex-shrink: 0; }
.fr-downloads .fr-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  margin: 0;
  border: 1px solid var(--kq-line);
  border-radius: 8px;
  background: transparent;
  color: var(--kq-accent);
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}
.fr-downloads .fr-btn:hover { background: rgba(0, 194, 168, 0.10); border-color: var(--kq-accent); }

/* Results | Inputs side by side on top; Fitted parameters full width below.
   (DOM order is Results, Fitted parameters, Inputs — \`order\` reshuffles it.) */
.fr-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  align-items: start;
}
.fr-grid > .fr-section:nth-child(1) { order: 1; }   /* Results */
.fr-grid > .fr-section:nth-child(3) { order: 2; }   /* Inputs */
.fr-grid > .fr-section:nth-child(2) {               /* Fitted parameters */
  order: 3;
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));   /* reactions side by side; a single reaction stretches full width */
  gap: 8px 10px;
  align-items: start;
}
.fr-grid > .fr-section:nth-child(2) > .fr-section-title,
.fr-grid > .fr-section:nth-child(2) > .fr-empty { grid-column: 1 / -1; }

.fr-section {
  padding: 8px 12px 10px;
  border: 1px solid var(--kq-line);
  border-radius: 10px;
  background: var(--kq-card);
  min-width: 0;
}
.fr-section-title {
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--kq-accent);
}
.fr-subtitle { margin: 8px 0 3px; font-size: 12px; font-weight: 700; color: var(--kq-ink); }
.fr-rx {
  padding: 6px 10px 8px;
  border: 1px solid var(--kq-line);
  border-radius: 8px;
  background: var(--kq-surface);
  min-width: 0;
}
.fr-rx .fr-subtitle { margin-top: 2px; color: var(--kq-accent); }

/* key / value tables: label left, value right, hairline between rows */
.fr-table { width: 100%; border-collapse: collapse; font-size: 12.5px; }
.fr-table th,
.fr-table td { padding: 3px 0; border-bottom: 1px solid var(--kq-line); vertical-align: top; }
.fr-table tr:last-child th,
.fr-table tr:last-child td { border-bottom: 0; }
.fr-table th {
  text-align: left;
  font-weight: 500;
  color: var(--kq-muted);
  padding-right: 10px;
}
.fr-table td {
  text-align: right;
  font-weight: 600;
  color: var(--kq-ink);
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.fr-empty { margin: 4px 0; font-size: 12.5px; color: var(--kq-muted); }
.fr-notes { margin: 8px 0 0; font-size: 12.5px; color: var(--kq-ink); }

@media (max-width: 900px) {
  .fr-grid { grid-template-columns: minmax(0, 1fr); }
  .fr-head { flex-direction: column; }
}

/* ── Reaction card: facts flow into as many columns as the width allows ── */
.fr-kv-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  column-gap: 20px;
}
.fr-kv {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 10px;
  padding: 4px 0;
  border-bottom: 1px solid var(--kq-line);
  font-size: 12.5px;
  min-width: 0;
}
.fr-kv-name { color: var(--kq-muted); font-weight: 500; }
.fr-kv-val {
  color: var(--kq-ink);
  font-weight: 600;
  text-align: right;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
/* long text (e.g. Aspen-ready dump) gets its own full-width line */
.fr-kv--wide { grid-column: 1 / -1; flex-direction: column; align-items: flex-start; gap: 2px; }
.fr-kv--wide .fr-kv-val { text-align: left; font-weight: 500; }

.fr-more {
  margin-top: 6px;
  padding: 3px 0;
  border: 0;
  background: none;
  color: var(--kq-accent);
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.fr-more:hover { text-decoration: underline; }

/* ── Use the full width: a single reaction card stretches across the panel ──
   (kept as its own late rule so it wins even if the earlier
   \`.fr-grid > .fr-section:nth-child(2)\` rule still says auto-fill)        */
.fr-grid > .fr-section:nth-child(2) {
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}
.fr-kv-grid { grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); }

/* ── Single reaction: key facts (left) | details incl. Aspen block (right) ──
   FIX (content overflowed its card): the card used to sit in ONE narrow grid
   track while its two inner columns needed more than that. It now spans the
   whole row, and the two columns are a wrapping flex row, so they can never
   spill outside the card — they sit side by side when there is room and stack
   when there isn't.                                                          */
.fr-rx--split {
  grid-column: 1 / -1;           /* take the full width of the Fitted parameters panel */
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0 18px;
}
.fr-rx--split > .fr-subtitle { flex: 0 0 100%; margin-bottom: 4px; }
.fr-rx--split > .fr-kv-grid  { flex: 1 1 300px; min-width: 0; }
.fr-rx--split > .fr-kv-grid:last-child { flex: 1.5 1 340px; }
.fr-kv-grid--one { grid-template-columns: minmax(0, 1fr); }
.fr-aspen .fr-kv-val { line-height: 1.45; font-weight: 500; }`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA,qBAAqB,eAAe,EAAE;;AAEtC,iBAAiB,gCAAgC,GAAG,cAAc,EAAE,sCAAsC,EAAE;AAC5G,iBAAiB,iCAAiC,EAAE,cAAc,EAAE,uCAAuC,EAAE;AAC7G,iBAAiB,gCAAgC,GAAG,cAAc,EAAE,sCAAsC,EAAE;;AAE5G,8DAA8D;AAC9D;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,eAAe,EAAE;;AAEvC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAErE;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,8DAA8D;AAC9D,kBAAkB,iCAAiC,EAAE,cAAc,EAAE;AACrE,kBAAkB,gCAAgC,GAAG,cAAc,EAAE;AACrE,kBAAkB,iCAAiC,EAAE,cAAc,EAAE;AACrE,kBAAkB,gCAAgC,GAAG,cAAc,EAAE;AACrE,kBAAkB,mBAAmB,gBAAgB,cAAc,EAAE;;AAErE,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;;AAEnC,8DAA8D;AAC9D;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA,sBAAsB,kBAAkB,EAAE;;AAE1C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,yBAAyB,mBAAmB,EAAE;;AAE9C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC;AACA,4BAA4B,mBAAmB,EAAE,iBAAiB,EAAE;;AAEpE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA,iBAAiB,WAAW,EAAE,kBAAkB,EAAE;;AAElD;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA,aAAa,iCAAiC,GAAG,cAAc,EAAE;AACjE,aAAa,gCAAgC,IAAI,cAAc,EAAE;AACjE,aAAa,iCAAiC,GAAG,cAAc,EAAE;;AAEjE,8DAA8D;AAC9D;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC;AACA,6BAA6B,mBAAmB,EAAE,iBAAiB,EAAE;;AAErE;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA,YAAY,mBAAmB,EAAE;AACjC,YAAY,mBAAmB,EAAE;AACjC,YAAY,mBAAmB,EAAE;;AAEjC;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA,kBAAkB,eAAe,EAAE,cAAc,EAAE;;AAEnD,8DAA8D;AAC9D;EACE,mBAAmB,qCAAqC,EAAE;EAC1D,aAAa,0BAA0B,EAAE;AAC3C;AACA;EACE,aAAa,kBAAkB,EAAE;EACjC,mBAAmB,8BAA8B,EAAE;EACnD,qBAAqB,0BAA0B,EAAE;AACnD;;AAEA;;;;;;;2EAO2E;;AAE3E;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB,IAAI,gHAAgH;EACzI,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd;;kFAEgF;EAChF,2CAA2C;AAC7C;;AAEA,kBAAkB,YAAY,EAAE;;AAEhC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,iCAAiC;EACjC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA,sBAAsB,kBAAkB,EAAE,qBAAqB,EAAE;;AAEjE;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,qBAAqB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;;AAEhE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA,uBAAuB,2BAA2B,EAAE;AACpD,0BAA0B,+BAA+B,EAAE,cAAc,EAAE;AAC3E,gCAAgC,mBAAmB,EAAE;AACrD;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;AACA,8BAA8B,kCAAkC,EAAE;;AAElE;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,oBAAoB,qBAAqB,EAAE,eAAe,EAAE;;AAE5D;EACE,aAAa,sBAAsB,EAAE,uBAAuB,EAAE;EAC9D,kBAAkB,mBAAmB,EAAE,eAAe,EAAE,uBAAuB,EAAE;AACnF;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA,kBAAkB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE;;AAErE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,kCAAkC,iCAAiC,EAAE,cAAc,EAAE;AACrF,qCAAqC,4BAA4B,EAAE,cAAc,EAAE;;AAEnF,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE;AAC/F,iBAAiB,gBAAgB,EAAE,eAAe,EAAE,0BAA0B,EAAE;;AAEhF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,kBAAkB,eAAe,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AACnG,yBAAyB,aAAa,EAAE;AACxC,kBAAkB,eAAe,EAAE;;AAEnC;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACtF,uBAAuB,SAAO,EAAE,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACxG;EACE,YAAY;EACZ,kBAAkB;EAClB,uEAAuE;EACvE,2BAA2B;AAC7B;AACA,uBAAuB,eAAe,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAElG;EACE,wBAAwB,0BAA0B,EAAE,SAAS,EAAE;AACjE;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA,qBAAqB,eAAe,EAAE,cAAc,EAAE;AACtD,qBAAqB,eAAe,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAElG;EACE,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,sBAAsB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAExE,uEAAuE;AACvE;EACE,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;AACX;AACA,6BAA6B,0BAA0B,EAAE,eAAe,EAAE;;AAE1E;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;AACtC;AACA,uCAAuC,UAAU,EAAE;AACnD,6CAA6C,mBAAmB,EAAE,kBAAkB,EAAE;AACtF,6CAA6C,uBAAuB,EAAE;;AAEtE;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,SAAS;EAC5B,YAAY;EACZ,oEAAoE;EACpE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gCAAgC;AAClC;AACA,4BAA4B,mBAAmB,EAAE,mBAAmB,EAAE;AACtE,gCAAgC,aAAa,EAAE;AAC/C,kBAAkB,SAAO,EAAE,YAAY,EAAE;AACzC;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,kBAAkB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEpE;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC1G,yBAAyB,cAAc,EAAE;AACzC,0BAA0B,cAAc,EAAE,eAAe,EAAE;AAC3D,mBAAmB,eAAe,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAE7E,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACpE;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,kBAAkB,YAAY,EAAE;AAChC,YAAY,0BAA0B,EAAE;AACxC,YAAY,mBAAmB,EAAE;AACjC,YAAY,mBAAmB,EAAE;;AAEjC,eAAe,aAAa,EAAE,eAAe,EAAE,aAAa,EAAE,eAAe,EAAE,sBAAsB,EAAE;AACvG,oBAAoB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACzE,mBAAmB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,qBAAqB,EAAE;;AAEvF,cAAc,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACtF;EACE,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;AAC3E;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,yBAAyB,iCAAiC,EAAE;AAC5D,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,oBAAoB,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE;AACrE,uBAAuB,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;;AAExE,oCAAoC,0BAA0B,EAAE;;AAEhE;EACE,qBAAqB,8BAA8B,EAAE;AACvD;AACA;EACE,qBAAqB,0BAA0B,EAAE;EACjD,aAAa,uBAAuB,EAAE,kBAAkB,EAAE;AAC5D;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA,4BAA4B,gBAAgB,EAAE;;AAE9C,4BAA4B,yBAAyB,8BAA8B,EAAE,EAAE;AACvF,4BAA4B,yBAAyB,0BAA0B,EAAE,EAAE;;AAEnF,8DAA8D;AAC9D,cAAc,yCAAyC,EAAE;AACzD,oBAAoB,uBAAuB,EAAE;AAC7C,iBAAiB,0BAA0B,EAAE;AAC7C,yBAAyB,mBAAmB,EAAE,mCAAmC,EAAE;;AAEnF,iEAAiE;AACjE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,kBAAkB,kBAAkB,EAAE;AACtC,iCAAiC,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtF;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA,6BAA6B,mBAAmB,EAAE;;AAElD,iEAAiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,eAAe,EAAE;AAC/F,mBAAmB,eAAe,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAChG,oBAAoB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AACtK;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA,0BAA0B,aAAa,EAAE,iCAAiC,EAAE,2CAA2C,EAAE;AACzH,sBAAsB,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAElH;;;;;;;;;;EAUE;;AAEF;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;AACA,0BAA0B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACnG,YAAY,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,SAAS,EAAE;AACjF,UAAU,eAAe,EAAE,sBAAsB,EAAE,eAAe,EAAE;AACpE,UAAU,eAAe,EAAE;;AAE3B,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA,cAAc,oBAAoB,EAAE,YAAY,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtG;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;AACA,iBAAiB,mBAAmB,EAAE,uBAAuB,EAAE,yCAAyC,EAAE;AAC1G;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA,mBAAmB,aAAa,EAAE,iCAAiC,EAAE;AACrE;EACE,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;qFACqF;AACrF,YAAY,mBAAmB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAE/H;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA,yBAAyB,mBAAmB,EAAE;AAC9C;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;AACA,wBAAwB,wBAAwB,EAAE;AAClD,iBAAiB,0BAA0B,EAAE,eAAe,EAAE,cAAc,EAAE;AAC9E;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,iBAAiB,oCAAoC,EAAE,sBAAsB,EAAE;;AAE/E;EACE,aAAa;EACb,uEAAuE;EACvE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;wCACwC,gCAAgC,EAAE;;AAE1E;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA,gBAAgB,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAChF,UAAU,cAAc,EAAE;;AAE1B,WAAW,iBAAiB,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AAC3E,UAAU,cAAc,EAAE;AAC1B,SAAS,kCAAkC,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AACrF,WAAW,cAAc,EAAE;;AAE3B,cAAc,oBAAoB,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AACjE;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA,mBAAmB,mBAAmB,EAAE,mCAAmC,EAAE,0BAA0B,EAAE;AACzG,2BAA2B,gCAAgC,EAAE,kCAAkC,EAAE,cAAc,EAAE;;AAEjH;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;AACA,gCAAgC,mBAAmB,EAAE;;AAErD;EACE,UAAU,+CAA+C,EAAE,YAAY,EAAE;EACzE,gBAAgB,aAAa,EAAE,IAAI,2DAA2D;EAC9F,mCAAmC,cAAc,EAAE;EACnD,cAAc,cAAc,EAAE,oBAAoB,EAAE,iBAAiB,EAAE;AACzE;;AAEA,mBAAmB,aAAa,EAAE,SAAS,EAAE;;AAE7C,4EAA4E;AAC5E,oBAAoB,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAEpE;;;;;;;;;2EAS2E;;AAE3E;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,6CAA6C;EAC7C,2CAA2C;EAC3C,4CAA4C;EAC5C,kDAAkD;EAClD,uBAAuB;;EAEvB,0CAA0C;EAC1C,gDAAgD;EAChD,4CAA4C;EAC5C,0CAA0C,SAAS,8BAA8B;EACjF,8CAA8C;EAC9C,gCAAgC;EAChC,gCAAgC,mBAAmB,uCAAuC;EAC1F,qBAAqB,8BAA8B,kBAAkB;;EAErE,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,4DAA4D;EAC5D,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,6DAA6D;EAC7D,gCAAgC;EAChC,uCAAuC;EACvC,gBAAgB;AAClB;AACA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,SAAS,EAAE,iBAAiB,EAAE,oBAAoB,EAAE;AAC1G,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACpF,kBAAkB,mBAAmB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtE;EACE,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,gCAAgC;EAChC,oBAAoB;EACpB,8CAA8C;AAChD;AACA,wBAAwB,8BAA8B,EAAE,gCAAgC,EAAE;AAC1F,oBAAoB,uBAAuB,EAAE;AAC7C,4BAA4B,aAAa,sBAAsB,EAAE,uBAAuB,EAAE,EAAE;;AAE5F,8DAA8D;AAC9D;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,uBAAuB,aAAa,EAAE,8BAA8B,EAAE,qBAAqB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC7H,wBAAwB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAC5F,wBAAwB,SAAS,EAAE;;AAEnC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;AACA,wBAAwB,8BAA8B,EAAE,gCAAgC,EAAE;AAC1F,gCAAgC,mCAAmC,EAAE,mBAAmB,EAAE;AAC1F,sBAAsB,kCAAkC,EAAE,gCAAgC,EAAE;AAC5F,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACjF,mCAAmC,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,0BAA0B,EAAE,6CAA6C,EAAE,0BAA0B,EAAE;AACxO,yCAAyC,uCAAuC,EAAE;AAClF,kCAAkC,cAAc,EAAE,SAAS,EAAE,eAAe,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACxH,iBAAiB,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,0BAA0B,EAAE,4BAA4B,EAAE,qBAAqB,EAAE,iBAAiB,EAAE;;AAE1O,iBAAiB,8CAA8C,EAAE,oBAAoB,EAAE;AACvF,kCAAkC,4BAA4B,EAAE,0BAA0B,EAAE;AAC5F,qCAAqC,4BAA4B,EAAE,0BAA0B,EAAE;;AAE/F,uBAAuB,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AACxH,sBAAsB,4BAA4B,EAAE;AACpD,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAElF,8DAA8D;AAC9D,oBAAoB,eAAe,EAAE;AACrC,sBAAsB,sBAAsB,EAAE;AAC9C,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACvE,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAErE;;EAEE,4BAA4B;EAC5B,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;gCACgC,8BAA8B,EAAE;AAChE,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;AAChE,kCAAkC,uBAAuB,EAAE,mBAAmB,EAAE;;AAEhF;oCACoC,uBAAuB,EAAE,oBAAoB,EAAE;AACnF,uBAAuB,0BAA0B,EAAE;;AAEnD,8DAA8D;AAC9D,qBAAqB,SAAS,EAAE,mBAAmB,EAAE;AACrD;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;AACzB;AACA,2BAA2B,sCAAsC,EAAE;AACnE,4BAA4B,+BAA+B,EAAE,uDAAuD,EAAE;AACtH,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,SAAS,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AACrI,sCAAsC,eAAe,EAAE,uBAAuB,EAAE;AAChF,sCAAsC,eAAe,EAAE,SAAS,EAAE;AAClE,qBAAqB,sBAAsB,EAAE;AAC7C,qBAAqB,sBAAsB,EAAE;AAC7C,4BAA4B,oBAAoB,EAAE;AAClD,sBAAsB,cAAc,EAAE;AACtC,4BAA4B,kBAAkB,EAAE;;AAEhD,oCAAoC,wEAAwE,EAAE;;AAE9G,8BAA8B;AAC9B,2BAA2B,oBAAoB,EAAE,sBAAsB,EAAE;AACzE,mBAAmB,gBAAgB,EAAE,YAAY,EAAE,UAAU,EAAE,eAAe,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AACxH,yBAAyB,uBAAuB,EAAE;AAClD,iCAAiC,mCAAmC,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC/G,cAAc,uBAAuB,EAAE,gCAAgC,EAAE;;AAEzE,oBAAoB,oCAAoC,EAAE;AAC1D,6CAA6C,mBAAmB,EAAE;;AAElE,8BAA8B;AAC9B,iBAAiB,mCAAmC,EAAE;AACtD;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB;EACvD,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;uBACuB,gCAAgC,EAAE;AACzD,kBAAkB,cAAc,EAAE,oBAAoB,EAAE;AACxD,kBAAkB,cAAc,EAAE,sBAAsB,EAAE;AAC1D,oBAAoB,cAAc,EAAE,iCAAiC,EAAE;;AAEvE,qEAAqE;AACrE,aAAa,QAAQ,EAAE;AACvB;EACE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB;EAC1D,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;AAC/B;AACA,qBAAqB,8BAA8B,EAAE;AACrD,mBAAmB,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE;AAC1E,yBAAyB,cAAc,EAAE;AACzC,0BAA0B,sBAAsB,EAAE,eAAe,EAAE;AACnE,mBAAmB,cAAc,EAAE,sBAAsB,EAAE,eAAe,EAAE;AAC5E,mBAAmB,sBAAsB,EAAE;AAC3C,2BAA2B,0BAA0B,EAAE;AACvD,UAAU,4BAA4B,EAAE;AACxC,mBAAmB,6DAA6D,EAAE;AAClF,eAAe,sBAAsB,EAAE;;AAEvC,gBAAgB;AAChB,mBAAmB,oBAAoB,EAAE,oBAAoB,EAAE;AAC/D,yBAAyB,gCAAgC,EAAE;AAC3D,yBAAyB,gCAAgC,EAAE;AAC3D,uBAAuB,gCAAgC,EAAE,uBAAuB,EAAE;AAClF,oBAAoB,oBAAoB,EAAE;AAC1C,0CAA0C,sBAAsB,EAAE;;AAElE,mCAAmC;AACnC,aAAa,iCAAiC,EAAE,cAAc,EAAE;AAChE,aAAa,iCAAiC,EAAE,cAAc,EAAE;AAChE,aAAa,iCAAiC,EAAE,cAAc,EAAE;;AAEhE,yBAAyB;AACzB;cACc,0BAA0B,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AAC1F,oBAAoB,mCAAmC,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAClG,yBAAyB,oBAAoB,EAAE;AAC/C,oCAAoC,sBAAsB,EAAE;;AAE5D,mBAAmB;AACnB,uBAAuB,2BAA2B,EAAE,4BAA4B,EAAE,uCAAuC,EAAE;AAC3H,uBAAuB,oBAAoB,EAAE;AAC7C,6BAA6B,gCAAgC,EAAE;;AAE/D,8DAA8D;AAC9D,uBAAuB,8BAA8B,EAAE;AACvD,cAAc,2BAA2B,EAAE,gCAAgC,EAAE,uCAAuC,EAAE;AACtH,oBAAoB,oBAAoB,EAAE;AAC1C,mBAAmB,sBAAsB,EAAE;AAC3C,oBAAoB,sBAAsB,EAAE;AAC5C,oBAAoB,0CAA0C,EAAE,gDAAgD,EAAE,oBAAoB,EAAE,oBAAoB,EAAE;AAC9J,iCAAiC,cAAc,EAAE;AACjD,0BAA0B,8BAA8B,EAAE,0CAA0C,EAAE;AACtG,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACtH,oCAAoC,SAAS,EAAE;AAC/C,yBAAyB,gBAAgB,EAAE,iBAAiB,EAAE,oCAAoC,EAAE;AACpG,oBAAoB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAClI,sBAAsB,uBAAuB,EAAE;AAC/C,oBAAoB,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAE3F,4EAA4E;AAC5E,YAAY,oBAAoB,EAAE;AAClC,UAAU,sBAAsB,EAAE;AAClC,cAAc,wBAAwB,EAAE;AACxC,cAAc,6BAA6B,EAAE;AAC7C,aAAa,sBAAsB,EAAE,oBAAoB,EAAE;AAC3D,iBAAiB,2BAA2B,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;AACzF,aAAa,0CAA0C,EAAE,gDAAgD,EAAE,oBAAoB,EAAE;AACjI,mBAAmB,8BAA8B,EAAE;AACnD,WAAW,cAAc,EAAE,iCAAiC,EAAE;AAC9D,YAAY,0BAA0B,EAAE,4BAA4B,EAAE;AACtE,mBAAmB,0BAA0B,EAAE;AAC/C,yBAAyB,6BAA6B,EAAE;AACxD,iBAAiB,oBAAoB,EAAE;AACvC,iBAAiB,gCAAgC,EAAE;AACnD,gBAAgB,sBAAsB,EAAE,mCAAmC,EAAE;AAC7E,wCAAwC,mCAAmC,EAAE;AAC7E,UAAU,qCAAqC,EAAE;AACjD,WAAW,sBAAsB,EAAE;AACnC,aAAa,sBAAsB,EAAE;AACrC,mBAAmB,gCAAgC,EAAE,kCAAkC,EAAE,uBAAuB,EAAE;AAClH,2BAA2B,gCAAgC,EAAE,iCAAiC,EAAE,cAAc,EAAE;AAChH,WAAW,gDAAgD,EAAE,uBAAuB,EAAE,oBAAoB,EAAE;AAC5G,iBAAiB,gCAAgC,EAAE;AACnD,cAAc,6BAA6B,EAAE,mCAAmC,EAAE;;AAElF,6BAA6B,qBAAqB,8BAA8B,EAAE,EAAE;AACpF;EACE,qBAAqB,0BAA0B,EAAE;EACjD,aAAa,uBAAuB,EAAE,kBAAkB,EAAE;EAC1D,uBAAuB,sBAAsB,EAAE,QAAQ,EAAE;AAC3D;AACA;EACE,iDAAiD,gBAAgB,EAAE;AACrE;;;AAGA,0DAA0D;AAC1D,oBAAoB,qCAAqC,EAAE;;;AAG3D,uEAAuE;AACvE,mBAAmB,mBAAmB,EAAE;AACxC,mBAAmB,sBAAsB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,SAAS,EAAE;AAC/J,mBAAmB,eAAe,EAAE,uBAAuB,EAAE,YAAY,EAAE;AAC3E,sCAAsC,gBAAgB,EAAE,kBAAkB,EAAE;AAC5E,qBAAqB,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,qBAAqB,EAAE,sBAAsB,EAAE,kCAAkC,EAAE;;AAEhP;;;;;6EAK6E;;AAE7E;;;;;yEAKyE;AACzE;EACE;IACE,wEAAwE;EAC1E;AACF;AACA,uBAAuB,gBAAgB,EAAE;AACzC,kCAAkC,iBAAiB,EAAE;AACrD,4BAA4B,mBAAmB,EAAE,IAAI,uCAAuC;;AAE5F,0EAA0E;AAC1E,cAAc,QAAQ,EAAE;AACxB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;AACA,sBAAsB,YAAY,EAAE,gBAAgB,EAAE;;AAEtD,4EAA4E;AAC5E,cAAc,kBAAkB,EAAE;;AAElC,aAAa,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE/D;EACE,aAAa;EACb,8BAA8B,MAAM,gCAAgC;EACpE,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,uCAAuC;AACzC;AACA,YAAY,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAChF,YAAY,eAAe,EAAE,eAAe,EAAE,sBAAsB,EAAE;;AAEtE,gBAAgB,aAAa,EAAE,QAAQ,EAAE,cAAc,EAAE;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA,8BAA8B,mCAAmC,EAAE,8BAA8B,EAAE;;AAEnG;+EAC+E;AAC/E;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;AACA,sCAAsC,QAAQ,EAAE,IAAI,YAAY;AAChE,sCAAsC,QAAQ,EAAE,IAAI,WAAW;AAC/D,oDAAoD,sBAAsB;EACxE,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,2DAA2D,IAAI,mEAAmE;EAClI,aAAa;EACb,kBAAkB;AACpB;AACA;kDACkD,mBAAmB,EAAE;;AAEvE;EACE,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA,eAAe,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAC3F;EACE,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;AACA,sBAAsB,eAAe,EAAE,uBAAuB,EAAE;;AAEhE,uEAAuE;AACvE,YAAY,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;AACvE;eACe,cAAc,EAAE,uCAAuC,EAAE,mBAAmB,EAAE;AAC7F;6BAC6B,gBAAgB,EAAE;AAC/C;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,YAAY,aAAa,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;AACtE,YAAY,eAAe,EAAE,iBAAiB,EAAE,oBAAoB,EAAE;;AAEtE;EACE,WAAW,qCAAqC,EAAE;EAClD,WAAW,sBAAsB,EAAE;AACrC;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,4DAA4D;EAC5D,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,uCAAuC;EACvC,iBAAiB;EACjB,YAAY;AACd;AACA,cAAc,sBAAsB,EAAE,gBAAgB,EAAE;AACxD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;AACzB;AACA,mEAAmE;AACnE,eAAe,mBAAmB,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AAC/F,0BAA0B,gBAAgB,EAAE,gBAAgB,EAAE;;AAE9D;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,iBAAiB,0BAA0B,EAAE;;AAE7C;;4EAE4E;AAC5E;EACE,2DAA2D;AAC7D;AACA,cAAc,4DAA4D,EAAE;;AAE5E;;;;;+EAK+E;AAC/E;EACE,mBAAmB,YAAY,uDAAuD;EACtF,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;AACA,+BAA+B,cAAc,EAAE,kBAAkB,EAAE;AACnE,+BAA+B,eAAe,EAAE,YAAY,EAAE;AAC9D,yCAAyC,iBAAiB,EAAE;AAC5D,mBAAmB,qCAAqC,EAAE;AAC1D,uBAAuB,iBAAiB,EAAE,gBAAgB,EAAE","sourcesContent":["/* Dashboard.css */\n\n/* ─── Page ─────────────────────────────────────────────── */\n.dash-page {\n  padding: 32px 40px;\n  font-family: 'Segoe UI', 'Inter', sans-serif;\n  color: #0f172a;\n  min-height: 100vh;\n  background: #f1f5f9;\n}\n\n/* ─── Top bar ───────────────────────────────────────────── */\n.dash-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.dash-greeting {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.dash-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n/* Role badge in top bar */\n.dash-role-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n.dash-role-badge i { font-size: 13px; }\n\n.badge-danger  { background: rgba(231,76,60,0.10);  color: #c0392b; border: 1px solid rgba(231,76,60,0.25); }\n.badge-info    { background: rgba(52,152,219,0.10); color: #1a7abf; border: 1px solid rgba(52,152,219,0.25); }\n.badge-success { background: rgba(39,174,96,0.10);  color: #1e8449; border: 1px solid rgba(39,174,96,0.25); }\n\n/* ─── Divider ───────────────────────────────────────────── */\n.dash-divider {\n  border: none;\n  border-top: 1px solid #e2e8f0;\n  margin: 0 0 24px;\n}\n\n/* ─── Stats grid ────────────────────────────────────────── */\n.dash-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n.dash-stat-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 16px 18px;\n}\n\n.dash-stat-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 10px;\n}\n\n.dash-stat-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n}\n\n.dash-stat-trend {\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n}\n.dash-stat-trend.up { color: #1e8449; }\n.dash-stat-trend i  { font-size: 12px; }\n\n.dash-stat-val {\n  font-size: 26px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1;\n}\n.dash-stat-unit { font-size: 14px; font-weight: 400; color: #64748b; }\n\n.dash-stat-lbl {\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 4px;\n}\n\n/* ─── Icon color helpers ────────────────────────────────── */\n.icon-info      { background: rgba(52,152,219,0.12); color: #1a7abf; }\n.icon-success   { background: rgba(39,174,96,0.12);  color: #1e8449; }\n.icon-warning   { background: rgba(243,156,18,0.12); color: #b7770d; }\n.icon-danger    { background: rgba(231,76,60,0.12);  color: #c0392b; }\n.icon-secondary { background: #f1f5f9;               color: #475569; }\n\n.color-info      { color: #1a7abf; }\n.color-success   { color: #1e8449; }\n.color-warning   { color: #b7770d; }\n.color-danger    { color: #c0392b; }\n.color-secondary { color: #475569; }\n\n/* ─── Body layout ───────────────────────────────────────── */\n.dash-body {\n  display: grid;\n  grid-template-columns: 1fr 320px;\n  gap: 16px;\n  align-items: start;\n}\n\n.dash-col-left,\n.dash-col-right {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ─── Panel ─────────────────────────────────────────────── */\n.dash-panel {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 20px 22px;\n}\n\n.dash-panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n}\n\n.dash-panel-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 14px;\n}\n\n.dash-view-all {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a7abf;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n/* ─── Quick actions ─────────────────────────────────────── */\n.dash-actions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 10px;\n}\n.dash-quick-actions { margin-bottom: 4px; }\n\n.dash-action-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n  cursor: pointer;\n  transition: background 0.15s;\n  text-align: left;\n}\n.dash-action-btn:hover { background: #f1f5f9; }\n\n.dash-action-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.dash-action-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n}\n.dash-action-sub {\n  display: block;\n  font-size: 11px;\n  color: #94a3b8;\n  margin-top: 1px;\n}\n\n/* ─── Recent projects ───────────────────────────────────── */\n.dash-proj-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n.dash-proj-row:last-child { border-bottom: none; padding-bottom: 0; }\n\n.dash-proj-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n.dash-proj-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #1e293b;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dash-proj-bar-wrap {\n  width: 72px;\n  height: 5px;\n  border-radius: 3px;\n  background: #e2e8f0;\n  flex-shrink: 0;\n}\n.dash-proj-bar { height: 5px; border-radius: 3px; }\n\n.dash-proj-pct {\n  font-size: 12px;\n  color: #64748b;\n  min-width: 30px;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.dash-status-pill {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 9px;\n  border-radius: 10px;\n  flex-shrink: 0;\n}\n.pill-run  { background: rgba(52,152,219,0.10);  color: #1a7abf; }\n.pill-done { background: rgba(39,174,96,0.10);   color: #1e8449; }\n.pill-wait { background: rgba(243,156,18,0.12);  color: #b7770d; }\n\n/* ─── Activity feed ─────────────────────────────────────── */\n.dash-feed-item {\n  display: flex;\n  gap: 12px;\n  padding: 9px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n.dash-feed-item:last-child { border-bottom: none; padding-bottom: 0; }\n\n.dash-feed-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n.dot-run  { background: #378ADD; }\n.dot-done { background: #27ae60; }\n.dot-warn { background: #f39c12; }\n\n.dash-feed-text {\n  font-size: 13px;\n  color: #334155;\n  line-height: 1.45;\n}\n.dash-feed-time {\n  font-size: 11px;\n  color: #94a3b8;\n  margin-top: 2px;\n}\n\n/* ─── Role card ─────────────────────────────────────────── */\n.dash-role-header {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  margin-bottom: 14px;\n}\n\n.dash-role-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 17px;\n  flex-shrink: 0;\n}\n\n.dash-role-name {\n  font-size: 14px;\n  font-weight: 700;\n  margin: 0 0 2px;\n}\n.dash-role-desc {\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.dash-cap-list {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n.dash-cap-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #334155;\n}\n.dash-cap-check { font-size: 14px; flex-shrink: 0; }\n\n/* ─── Responsive ────────────────────────────────────────── */\n@media (max-width: 900px) {\n  .dash-stats-grid { grid-template-columns: repeat(2, 1fr); }\n  .dash-body { grid-template-columns: 1fr; }\n}\n@media (max-width: 560px) {\n  .dash-page { padding: 20px 16px; }\n  .dash-stats-grid { grid-template-columns: 1fr 1fr; }\n  .dash-actions-grid { grid-template-columns: 1fr; }\n}\n\n/* ══════════════════════════════════════════════════════════════════════\n * DASHBOARD REDESIGN ADDITIONS (v2 — landing-page look, fixed-height cards)\n * Everything below is new; nothing above this line was changed, so any\n * other page still importing dash-* classes keeps working as-is.\n *\n * Palette is taken from the KinetiQ landing page (kinetiq.vidyayug.com):\n * deep navy hero, teal accent, soft white cards.\n * ══════════════════════════════════════════════════════════════════════ */\n\n.dash-page {\n  --kq-navy:      #0b1f4a;\n  --kq-navy-2:    #12306b;\n  --kq-teal:      #14c8b0;\n  --kq-teal-dark: #0e8fa8;\n  --kq-ink:       #0f172a;\n  --kq-muted:     #64748b;\n  --kq-line:      #e2e8f0;\n  --kq-card-h:    296px;   /* trimmed from 320px to cut page scroll, kept enough headroom for the Performance card's three stacked blocks */\n  background: #f1f5f9;\n  padding: 20px 32px 32px;\n}\n\n/* ─── Hero banner ───────────────────────────────────────── */\n.dash-hero {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 24px;\n  padding: 16px 26px;\n  margin-bottom: 14px;\n  border-radius: 16px;\n  color: #ffffff;\n  background:\n    radial-gradient(520px 200px at 88% -10%, rgba(20,200,176,0.30), transparent 65%),\n    linear-gradient(120deg, var(--kq-navy) 0%, var(--kq-navy-2) 62%, #0f3d78 100%);\n  box-shadow: 0 10px 28px rgba(11,31,74,0.18);\n}\n\n.dash-hero-main { min-width: 0; }\n\n.dash-hero-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  border: 1px solid rgba(20,200,176,0.45);\n  background: rgba(20,200,176,0.10);\n  color: var(--kq-teal);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.10em;\n  text-transform: uppercase;\n}\n\n.dash-hero-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--kq-teal);\n}\n\n.dash-hero-title {\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.25;\n  letter-spacing: -0.01em;\n  margin: 8px 0 4px;\n  color: #ffffff;\n}\n.dash-hero-title em { font-style: normal; color: var(--kq-teal); }\n\n.dash-hero-sub {\n  font-size: 13px;\n  color: rgba(255,255,255,0.72);\n  margin: 0 0 12px;\n}\n\n.dash-hero-actions { display: flex; gap: 10px; flex-wrap: wrap; }\n\n.dash-hero-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 18px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: transform 0.12s, background 0.15s;\n}\n.dash-hero-btn:hover { transform: translateY(-1px); }\n.dash-hero-btn--primary { background: var(--kq-teal-dark); color: #ffffff; }\n.dash-hero-btn--primary:hover { background: #0b7d94; }\n.dash-hero-btn--ghost {\n  background: rgba(255,255,255,0.08);\n  border-color: rgba(255,255,255,0.25);\n  color: #ffffff;\n}\n.dash-hero-btn--ghost:hover { background: rgba(255,255,255,0.15); }\n\n.dash-hero-side {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.dash-hero-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 6px 13px;\n  border-radius: 20px;\n  background: rgba(255,255,255,0.10);\n  border: 1px solid rgba(255,255,255,0.18);\n  font-size: 12px;\n  font-weight: 600;\n  color: #e6eefb;\n}\n.dash-hero-chip i { color: var(--kq-teal); font-size: 14px; }\n\n@media (max-width: 900px) {\n  .dash-hero { flex-direction: column; align-items: flex-start; }\n  .dash-hero-side { flex-direction: row; flex-wrap: wrap; align-items: flex-start; }\n}\n\n/* ─── Getting Started checklist ─────────────────────────── */\n.dash-checklist-card {\n  background: #ffffff;\n  border: 1px solid var(--kq-line);\n  border-radius: 14px;\n  padding: 14px 22px 12px;\n  margin-bottom: 14px;\n  box-shadow: 0 1px 2px rgba(15,23,42,0.04);\n}\n\n.dash-checklist-title {\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--kq-navy);\n  margin: 0 0 10px;\n}\n\n.dash-checklist-steps {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n  align-items: start;\n}\n\n.dash-step-head { display: flex; align-items: flex-start; gap: 10px; }\n\n.dash-step-num {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #e2e8f0;\n  color: var(--kq-muted);\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dash-step--done .dash-step-num { background: rgba(20,200,176,0.16); color: #0b8f7e; }\n.dash-step--current .dash-step-num { background: var(--kq-navy-2); color: #ffffff; }\n\n.dash-step-label { font-size: 14px; font-weight: 700; color: var(--kq-ink); line-height: 24px; }\n.dash-step-tag { font-weight: 500; font-size: 12px; color: var(--kq-teal-dark); }\n\n.dash-step-pending {\n  display: inline-block;\n  margin-left: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #94a3b8;\n  background: #f1f5f9;\n  border-radius: 10px;\n  padding: 1px 8px;\n  vertical-align: middle;\n}\n\n.dash-step-desc { font-size: 12px; color: var(--kq-muted); line-height: 1.5; margin: 6px 0 0 34px; }\n.dash-step-desc--muted { opacity: 0.85; }\n.dash-step-body { margin-top: 8px; }\n\n.dash-step-cta {\n  margin-left: 34px;\n  background: var(--kq-teal-dark);\n  color: #ffffff;\n  border: none;\n  border-radius: 9px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.dash-step-cta:hover { background: #0b7d94; }\n\n.dash-progress-row { display: flex; align-items: center; gap: 12px; margin-top: 16px; }\n.dash-progress-track { flex: 1; height: 6px; border-radius: 3px; background: #e2e8f0; overflow: hidden; }\n.dash-progress-fill {\n  height: 100%;\n  border-radius: 3px;\n  background: linear-gradient(90deg, var(--kq-teal-dark), var(--kq-teal));\n  transition: width 0.3s ease;\n}\n.dash-progress-label { font-size: 12px; color: var(--kq-muted); font-weight: 700; flex-shrink: 0; }\n\n@media (max-width: 900px) {\n  .dash-checklist-steps { grid-template-columns: 1fr; gap: 16px; }\n}\n\n/* ─── Three summary cards ───────────────────────────────── */\n.dash-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(var(--dash-cols, 3), minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 14px;\n  align-items: stretch;\n}\n\n.dash-summary-card {\n  position: relative;\n  background: #ffffff;\n  border: 1px solid var(--kq-line);\n  border-radius: 14px;\n  padding: 18px 18px 14px;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  box-shadow: 0 1px 2px rgba(15,23,42,0.04);\n}\n\n/* Empty state — dashed card, centered icon/copy/CTA (per mockup) */\n.dash-summary-card--empty {\n  min-height: 230px;\n  border: 1.5px dashed #cbd5e1;\n  background: rgba(255,255,255,0.6);\n  box-shadow: none;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 12px;\n}\n\n.dash-summary-icon { font-size: 40px; color: #94a3b8; }\n.dash-summary-text { font-size: 13px; color: var(--kq-muted); line-height: 1.5; max-width: 240px; }\n\n.dash-summary-cta {\n  background: var(--kq-teal-dark);\n  color: #ffffff;\n  border: none;\n  border-radius: 9px;\n  padding: 9px 18px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.dash-summary-cta:hover { background: #0b7d94; }\n.dash-summary-error { font-size: 11px; color: #c0392b; margin-top: 8px; }\n\n/* Populated state — fixed height so all three cards line up, no gaps */\n.dash-summary-card--data {\n  height: var(--kq-card-h);\n  border-top: 3px solid var(--kq-teal);\n  overflow: hidden;\n}\n\n.dash-summary-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  flex-shrink: 0;\n}\n\n.dash-summary-card-title {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--kq-navy-2);\n  margin: 0;\n}\n.dash-summary-card-title i { color: var(--kq-teal-dark); font-size: 15px; }\n\n.dash-count {\n  min-width: 22px;\n  text-align: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--kq-teal-dark);\n  background: rgba(14,143,168,0.10);\n  border-radius: 10px;\n  padding: 2px 8px;\n}\n\n/* The scroll area — thin scrollbar, bottom fade hints there's more */\n.dash-card-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding-right: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n.dash-card-scroll::-webkit-scrollbar { width: 6px; }\n.dash-card-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }\n.dash-card-scroll::-webkit-scrollbar-track { background: transparent; }\n\n.dash-summary-card--scroll::after {\n  content: '';\n  position: absolute;\n  left: 0; right: 0; bottom: 0;\n  height: 26px;\n  background: linear-gradient(to bottom, rgba(255,255,255,0), #ffffff);\n  border-radius: 0 0 14px 14px;\n  pointer-events: none;\n}\n\n/* Card 1 — activity rows */\n.dash-feed-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 4px;\n  border-bottom: 1px solid #f1f5f9;\n}\n.dash-feed-row:last-child { border-bottom: none; margin-bottom: 18px; }\n.dash-feed-row .dash-feed-dot { margin-top: 0; }\n.dash-feed-main { flex: 1; min-width: 0; }\n.dash-feed-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--kq-ink);\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dash-feed-when { font-size: 11px; color: #94a3b8; margin: 2px 0 0; }\n\n.dash-example-tag {\n  display: inline-block;\n  margin-left: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #b7770d;\n  background: rgba(243,156,18,0.14);\n  border-radius: 8px;\n  padding: 1px 7px;\n  vertical-align: middle;\n}\n\n/* Card 2 — performance (fills the whole card) */\n.dash-perf {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 10px;\n  padding-bottom: 4px;\n}\n\n.dash-metric-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n.dash-metric {\n  text-align: center;\n  padding: 12px 4px;\n  border-radius: 10px;\n  background: #f8fafc;\n  border: 1px solid #eef2f7;\n}\n.dash-metric-val { font-size: 24px; font-weight: 800; color: var(--kq-navy); margin: 0; line-height: 1.1; }\n.dash-metric-val--good { color: #0b8f7e; }\n.dash-metric-val--muted { color: #94a3b8; font-size: 18px; }\n.dash-metric-lbl { font-size: 11px; color: var(--kq-muted); margin: 4px 0 0; }\n\n.dash-perf-block { display: flex; flex-direction: column; gap: 6px; }\n.dash-perf-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--kq-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.dash-stack {\n  display: flex;\n  height: 10px;\n  border-radius: 5px;\n  overflow: hidden;\n  background: #e2e8f0;\n}\n.dash-stack-seg { height: 100%; }\n.seg-ok   { background: var(--kq-teal); }\n.seg-warn { background: #f5a524; }\n.seg-bad  { background: #e5534b; }\n\n.dash-legend { display: flex; flex-wrap: wrap; gap: 4px 14px; font-size: 11px; color: var(--kq-muted); }\n.dash-legend span { display: inline-flex; align-items: center; gap: 5px; }\n.dash-legend-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; }\n\n.dash-meter { height: 8px; border-radius: 4px; background: #e2e8f0; overflow: hidden; }\n.dash-meter-fill {\n  height: 100%;\n  border-radius: 4px;\n  background: linear-gradient(90deg, var(--kq-navy-2), var(--kq-teal-dark));\n}\n\n/* Card 3 — folder rows */\n.dash-folder-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 6px;\n  border: none;\n  background: none;\n  border-radius: 9px;\n  cursor: pointer;\n  text-align: left;\n  width: 100%;\n}\n.dash-folder-row:hover { background: #f1f7fb; }\n.dash-folder-row--open { background: rgba(20,200,176,0.10); }\n.dash-folder-row:last-child { margin-bottom: 18px; }\n\n.dash-folder-iconbox {\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(14,143,168,0.10);\n  color: var(--kq-teal-dark);\n  font-size: 15px;\n}\n\n.dash-folder-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--kq-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dash-folder-meta { font-size: 11px; color: #94a3b8; flex-shrink: 0; }\n.dash-folder-chevron { color: #94a3b8; font-size: 12px; flex-shrink: 0; }\n\n.dash-summary-card .dash-view-all { color: var(--kq-teal-dark); }\n\n@media (max-width: 1100px) {\n  .dash-summary-grid { grid-template-columns: 1fr 1fr; }\n}\n@media (max-width: 720px) {\n  .dash-summary-grid { grid-template-columns: 1fr; }\n  .dash-page { padding: 18px 14px 32px; --kq-card-h: 300px; }\n}\n\n/* ─── Run summary panel ─────────────────────────────────── */\n.dash-run-summary {\n  background: #ffffff;\n  border: 1px solid var(--kq-line);\n  border-left: 3px solid var(--kq-teal);\n  border-radius: 14px;\n  padding: 16px 22px;\n  margin-bottom: 18px;\n}\n\n.dash-run-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px 24px;\n  font-size: 13px;\n  color: var(--kq-ink);\n  font-weight: 600;\n}\n.dash-run-summary-notes { grid-column: 1 / -1; }\n\n.dash-td-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 2px;\n}\n.dash-run-summary-actions { margin-top: 12px; }\n\n@media (max-width: 900px) { .dash-run-summary-grid { grid-template-columns: 1fr 1fr; } }\n@media (max-width: 560px) { .dash-run-summary-grid { grid-template-columns: 1fr; } }\n\n/* ─── Lower panels pick up the same card polish ─────────── */\n.dash-panel { box-shadow: 0 1px 2px rgba(15,23,42,0.04); }\n.dash-panel-title { color: var(--kq-navy-2); }\n.dash-view-all { color: var(--kq-teal-dark); }\n.dash-action-btn:hover { background: #f1f7fb; border-color: rgba(14,143,168,0.35); }\n\n/* ─── Overview bar + \"Customize\" cards menu (item #22) ─────── */\n.dash-section-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 2px 8px;\n}\n.dash-section-title {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--kq-muted);\n}\n.dash-customize { position: relative; }\n.dash-customize .dash-view-all { display: inline-flex; align-items: center; gap: 6px; }\n.dash-customize-menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n  z-index: 20;\n  min-width: 220px;\n  padding: 8px;\n  background: #ffffff;\n  border: 1px solid var(--kq-line);\n  border-radius: 10px;\n  box-shadow: 0 10px 24px rgba(15,23,42,0.14);\n}\n.dash-customize-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 8px;\n  border-radius: 7px;\n  font-size: 13px;\n  color: var(--kq-ink);\n  cursor: pointer;\n}\n.dash-customize-item:hover { background: #f1f7fb; }\n\n/* ─── Setup modal (checklist step 1) ───────────────────────── */\n.dash-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(11,31,74,0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n.dash-modal {\n  width: 100%;\n  max-width: 420px;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 22px 24px;\n  box-shadow: 0 20px 48px rgba(11,31,74,0.30);\n}\n.dash-modal-title { font-size: 16px; font-weight: 800; color: var(--kq-navy); margin: 0 0 6px; }\n.dash-modal-text { font-size: 12px; color: var(--kq-muted); line-height: 1.5; margin: 0 0 14px; }\n.dash-modal-label { display: block; font-size: 11px; font-weight: 700; color: var(--kq-muted); text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px; }\n.dash-modal-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 9px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  font-size: 14px;\n  color: var(--kq-ink);\n}\n.dash-modal-input:focus { outline: none; border-color: var(--kq-teal-dark); box-shadow: 0 0 0 3px rgba(14,143,168,0.15); }\n.dash-modal-actions { display: flex; justify-content: flex-end; align-items: center; gap: 14px; margin-top: 18px; }\n\n/* ─── Run History page (/run-history) ────────────────────────\n * Rewritten for readability + less scrolling:\n *   - rows use CSS Grid (fixed columns) instead of flex, so name/model/R²/\n *     date/status/actions always line up and never run together\n *   - each reaction-system group is a collapsible <button> header, closed\n *     by default except the first, so 4 systems worth of history doesn't\n *     dump every row on screen at once\n *   - a group with many runs shows 5 at a time with \"Show N more\"\n *   - action buttons are compact icon buttons with a visible hit target,\n *     not bare text jammed next to each other\n */\n\n.rh-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n.rh-head .dash-view-all { display: inline-flex; align-items: center; gap: 6px; margin-bottom: 6px; }\n.rh-title { font-size: 22px; font-weight: 800; color: var(--kq-navy); margin: 0; }\n.rh-sub { font-size: 13px; color: var(--kq-muted); margin: 3px 0 0; }\n.rh-btn { font-size: 13px; }\n\n/* Sticky so filtering/searching doesn't require scrolling back to the top */\n.rh-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 10px 0;\n  margin-bottom: 4px;\n  background: #f1f5f9;\n}\n.rh-filters { display: inline-flex; padding: 3px; background: #e8eef5; border-radius: 10px; gap: 2px; }\n.rh-filter {\n  border: none;\n  background: transparent;\n  padding: 6px 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--kq-muted);\n  cursor: pointer;\n}\n.rh-filter--on { background: #ffffff; color: var(--kq-navy-2); box-shadow: 0 1px 2px rgba(15,23,42,0.10); }\n.rh-search {\n  min-width: 220px;\n  padding: 8px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  font-size: 13px;\n  background: #ffffff;\n}\n.rh-search:focus { outline: none; border-color: var(--kq-teal-dark); }\n.rh-note {\n  font-size: 12px;\n  color: #b7770d;\n  background: rgba(243,156,18,0.10);\n  border-radius: 8px;\n  padding: 7px 12px;\n  margin: 0 0 10px;\n}\n\n/* One column definition shared by the header row and every data row, so\n   everything stays aligned: checkbox | name | model | R² | date | status | actions */\n.rh-group { margin-bottom: 10px; background: #ffffff; border: 1px solid var(--kq-line); border-radius: 12px; overflow: hidden; }\n\n.rh-group-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 12px 16px;\n  background: #ffffff;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n}\n.rh-group-header:hover { background: #f8fafc; }\n.rh-group-caret {\n  font-size: 13px;\n  color: #94a3b8;\n  transition: transform 0.15s ease;\n  flex-shrink: 0;\n}\n.rh-group-caret--open { transform: rotate(90deg); }\n.rh-group-icon { color: var(--kq-teal-dark); font-size: 15px; flex-shrink: 0; }\n.rh-group-name {\n  flex: 1;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--kq-navy-2);\n}\n\n.rh-group-body { border-top: 1px solid var(--kq-line); padding: 4px 10px 10px; }\n\n.rh-row {\n  display: grid;\n  grid-template-columns: 22px minmax(0, 1.6fr) 1fr 0.7fr 1.1fr 0.9fr auto;\n  align-items: center;\n  column-gap: 12px;\n  padding: 9px 6px;\n}\n.rh-row-wrap + .rh-row-wrap .rh-row,\n.rh-row-wrap:not(:last-child) .rh-row { border-bottom: 1px solid #f1f5f9; }\n\n.rh-row--head {\n  padding: 4px 6px 8px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  border-bottom: 1px solid var(--kq-line);\n}\n\n.rh-name {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--kq-ink);\n}\n.rh-name-text { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.rh-tag { flex-shrink: 0; }\n\n.rh-meta { font-size: 12.5px; color: var(--kq-muted); white-space: nowrap; }\n.rh-dim { color: #b3bcc9; }\n.rh-r2 { font-variant-numeric: tabular-nums; color: var(--kq-ink); font-weight: 600; }\n.rh-date { color: #94a3b8; }\n\n.rh-actions { display: inline-flex; gap: 4px; justify-self: end; }\n.rh-action {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  background: transparent;\n  border-radius: 7px;\n  color: var(--kq-muted);\n  font-size: 14px;\n  cursor: pointer;\n}\n.rh-action:hover { background: #f1f7fb; border-color: rgba(14,143,168,0.25); color: var(--kq-teal-dark); }\n.rh-action--danger:hover { background: rgba(192,57,43,0.08); border-color: rgba(192,57,43,0.25); color: #c0392b; }\n\n.rh-more {\n  width: 100%;\n  margin-top: 4px;\n  padding: 8px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--kq-teal-dark);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n.rh-more:hover { background: #f1f7fb; }\n\n.rh-summary {\n  margin: 2px 0 8px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  border-left: 3px solid var(--kq-teal);\n  border-radius: 8px;\n}\n.rh-summary .dash-panel-title { margin-bottom: 10px; }\n\n@media (max-width: 900px) {\n  .rh-row { grid-template-columns: 20px minmax(0, 1fr) auto; row-gap: 4px; }\n  .rh-row--head { display: none; }   /* column header doesn't make sense once columns collapse */\n  .rh-meta.rh-r2, .rh-meta.rh-date { grid-column: 2; }\n  .rh-actions { grid-column: 3; grid-row: 1 / span 2; align-self: start; }\n}\n\n.rh-head-actions { display: flex; gap: 10px; }\n\n/* ─── Systems page (/systems) — reuses Run History's row/grid classes ─── */\n.sys-rename-input { width: 100%; padding: 5px 9px; font-size: 13px; }\n\n/* ══════════════════════════════════════════════════════════════════════\n * REVISION — client items #2, #3, #4, #5  (compact layout + DARK THEME)\n * Appended last so it wins over everything above. The dark tokens mirror\n * DataFittingPage.css (\"Dark theme (default)\"); fallbacks are included so\n * this file also works if that stylesheet isn't loaded yet.\n *\n * Branding note (#5 \"ask before changing any branding element\"): this block\n * only recolors the dashboard surfaces to the existing Data Fitting palette.\n * Logo, product name and the top Navbar are untouched.\n * ══════════════════════════════════════════════════════════════════════ */\n\n.dash-page {\n  --kq-bg:        var(--color-bg, #0B1826);\n  --kq-card:      var(--color-card, #12253D);\n  --kq-surface:   var(--color-surface, #0F2135);\n  --kq-panel:     var(--color-panel, #142A44);\n  --kq-accent:    var(--color-accent, #00C2A8);\n  --kq-accent-h:  var(--color-accent-hover, #00A88F);\n  --kq-on-accent: #062a33;\n\n  --kq-ink:       var(--color-text, #F0F7FA);\n  --kq-muted:     var(--color-text-muted, #93A9BC);\n  --kq-line:      var(--color-border, #1F3350);\n  --kq-navy:      var(--color-text, #F0F7FA);        /* titles were navy-on-white */\n  --kq-navy-2:    var(--color-text-mid, #B9CBD8);\n  --kq-teal:      var(--kq-accent);\n  --kq-teal-dark: var(--kq-accent);                  /* links/icons: bright accent on dark */\n  --kq-card-h:    236px;                             /* #2: was 296px */\n\n  background: var(--kq-bg);\n  color: var(--kq-ink);\n  padding: 16px 28px 28px;\n  font-family: var(--font-ui, 'Inter', 'Segoe UI', sans-serif);\n  min-height: 100%;\n}\n\n/* ─── #2 Compact welcome banner ─────────────────────────── */\n.dash-hero {\n  padding: 12px 20px;\n  margin-bottom: 12px;\n  border-radius: 12px;\n  background: linear-gradient(120deg, #0F2135 0%, #142A44 100%);\n  border: 1px solid var(--kq-line);\n  border-left: 3px solid var(--kq-accent);\n  box-shadow: none;\n}\n.dash-hero-title { font-size: 17px; font-weight: 700; margin: 0; letter-spacing: 0; color: var(--kq-ink); }\n.dash-hero-title em { font-style: normal; font-weight: 500; color: var(--kq-muted); }\n.dash-hero-side { flex-direction: row; align-items: center; gap: 8px; }\n.dash-hero-chip {\n  font-family: inherit;\n  cursor: pointer;\n  background: rgba(255,255,255,0.05);\n  border: 1px solid var(--kq-line);\n  color: var(--kq-ink);\n  transition: border-color .15s, background .15s;\n}\n.dash-hero-chip:hover { border-color: var(--kq-accent); background: rgba(0,194,168,0.10); }\n.dash-hero-chip i { color: var(--kq-accent); }\n@media (max-width: 900px) { .dash-hero { flex-direction: column; align-items: flex-start; } }\n\n/* ─── #3 / #4 Getting started: every step is a link ─────── */\n.dash-checklist-card {\n  background: var(--kq-card);\n  border: 1px solid var(--kq-line);\n  padding: 12px 16px 12px;\n  margin-bottom: 12px;\n  box-shadow: none;\n}\n.dash-checklist-head { display: flex; justify-content: space-between; align-items: baseline; gap: 12px; margin-bottom: 10px; }\n.dash-checklist-title { margin: 0; font-size: 14px; font-weight: 700; color: var(--kq-ink); }\n.dash-checklist-steps { gap: 10px; }\n\n.dash-step-link {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  text-align: left;\n  font-family: inherit;\n  color: var(--kq-ink);\n  background: transparent;\n  border: 1px solid var(--kq-line);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: border-color .15s, background .15s;\n}\n.dash-step-link:hover { border-color: var(--kq-accent); background: rgba(0,194,168,0.07); }\n.dash-step-link:focus-visible { outline: 2px solid var(--kq-accent); outline-offset: 2px; }\n.dash-step--current { border-color: rgba(0,194,168,0.55); background: rgba(0,194,168,0.07); }\n.dash-step-text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }\n.dash-step-link .dash-step-label { display: block; font-size: 13.5px; font-weight: 700; line-height: 22px; color: var(--kq-ink); text-decoration: underline; text-decoration-color: rgba(147,169,188,0.45); text-underline-offset: 3px; }\n.dash-step-link:hover .dash-step-label { text-decoration-color: var(--kq-accent); }\n.dash-step-link .dash-step-desc { display: block; margin: 0; font-size: 12px; color: var(--kq-muted); line-height: 1.4; }\n.dash-step-tag { margin-left: 8px; padding: 1px 8px; border-radius: 10px; font-size: 10.5px; font-weight: 700; text-decoration: none; color: var(--kq-on-accent); background: var(--kq-accent); display: inline-block; line-height: 16px; }\n\n.dash-step-num { background: var(--color-border-light, #2A415F); color: var(--kq-ink); }\n.dash-step--done .dash-step-num { background: var(--kq-accent); color: var(--kq-on-accent); }\n.dash-step--current .dash-step-num { background: var(--kq-accent); color: var(--kq-on-accent); }\n\n.dash-progress-track { height: 5px; margin-top: 12px; border-radius: 3px; background: var(--kq-line); overflow: hidden; }\n.dash-progress-fill { background: var(--kq-accent); }\n.dash-progress-label { font-size: 12px; font-weight: 600; color: var(--kq-muted); }\n\n/* ─── Overview bar with the single run button (#4) ──────── */\n.dash-section-bar { margin: 0 0 8px; }\n.dash-section-title { color: var(--kq-muted); }\n.dash-section-actions { display: flex; align-items: center; gap: 14px; }\n.dash-run-btn { display: inline-flex; align-items: center; gap: 7px; }\n\n.dash-summary-cta,\n.dash-hero-btn--primary {\n  background: var(--kq-accent);\n  color: var(--kq-on-accent);\n  font-family: inherit;\n}\n.dash-summary-cta:hover,\n.dash-hero-btn--primary:hover { background: var(--kq-accent-h); }\n.dash-summary-cta:disabled { opacity: .45; cursor: not-allowed; }\n.dash-summary-cta:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }\n\n.dash-view-all,\n.dash-summary-card .dash-view-all { color: var(--kq-accent); font-family: inherit; }\n.dash-view-all:hover { text-decoration: underline; }\n\n/* ─── Cards ─────────────────────────────────────────────── */\n.dash-summary-grid { gap: 12px; margin-bottom: 12px; }\n.dash-summary-card {\n  background: var(--kq-card);\n  border: 1px solid var(--kq-line);\n  box-shadow: none;\n  padding: 14px 16px 12px;\n}\n.dash-summary-card--data { border-top: 2px solid var(--kq-accent); }\n.dash-summary-card--empty { background: rgba(18,37,61,0.55); border: 1.5px dashed var(--color-border-light, #2A415F); }\n.dash-first-card { min-height: 0; flex-direction: row; padding: 22px 24px; gap: 16px; justify-content: flex-start; text-align: left; }\n.dash-first-card .dash-summary-icon { font-size: 28px; color: var(--kq-accent); }\n.dash-first-card .dash-summary-text { max-width: none; margin: 0; }\n.dash-summary-icon { color: var(--kq-muted); }\n.dash-summary-text { color: var(--kq-muted); }\n.dash-summary-text strong { color: var(--kq-ink); }\n.dash-summary-error { color: #f2555a; }\n.dash-summary-card-header { margin-bottom: 8px; }\n\n.dash-summary-card--scroll::after { background: linear-gradient(to bottom, rgba(18,37,61,0), var(--kq-card)); }\n\n/* card titles are links now */\n.dash-summary-card-title { color: var(--kq-ink); letter-spacing: 0.05em; }\n.dash-title-link { background: none; border: none; padding: 0; cursor: pointer; font-family: inherit; text-align: left; }\n.dash-title-link:hover { color: var(--kq-accent); }\n.dash-title-link:focus-visible { outline: 2px solid var(--kq-accent); outline-offset: 3px; border-radius: 4px; }\n.dash-count { color: var(--kq-accent); background: rgba(0,194,168,0.14); }\n\n.dash-card-scroll { scrollbar-color: #2A415F transparent; }\n.dash-card-scroll::-webkit-scrollbar-thumb { background: #2A415F; }\n\n/* activity rows are buttons */\n.dash-feed-row { border-bottom-color: var(--kq-line); }\n.dash-feed-row--btn {\n  width: 100%;\n  background: none;\n  border-left: none; border-right: none; border-top: none;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  border-radius: 8px;\n  color: inherit;\n}\n.dash-feed-row--btn:hover,\n.dash-feed-row--open { background: rgba(0,194,168,0.09); }\n.dash-feed-name { display: block; color: var(--kq-ink); }\n.dash-feed-when { display: block; color: var(--kq-muted); }\n.dash-example-tag { color: #F4A261; background: rgba(244,162,97,0.16); }\n\n/* performance tiles are buttons (compact so the shorter card fits) */\n.dash-perf { gap: 8px; }\n.dash-metric {\n  display: flex; flex-direction: column; align-items: center;\n  padding: 8px 4px;\n  font-family: inherit;\n  cursor: pointer;\n  background: var(--kq-surface);\n  border: 1px solid var(--kq-line);\n  transition: border-color .15s;\n}\n.dash-metric:hover { border-color: var(--kq-accent); }\n.dash-metric-val { display: block; font-size: 20px; color: var(--kq-ink); }\n.dash-metric-val--good { color: #2FBE84; }\n.dash-metric-val--muted { color: var(--kq-muted); font-size: 16px; }\n.dash-metric-lbl { display: block; color: var(--kq-muted); margin: 2px 0 0; }\n.dash-perf-label { color: var(--kq-muted); }\n.dash-stack, .dash-meter { background: var(--kq-line); }\n.seg-ok { background: var(--kq-accent); }\n.dash-meter-fill { background: linear-gradient(90deg, #0B8DA6, var(--kq-accent)); }\n.dash-legend { color: var(--kq-muted); }\n\n/* folder rows */\n.dash-folder-row { color: var(--kq-ink); font-family: inherit; }\n.dash-folder-row:hover { background: rgba(0,194,168,0.09); }\n.dash-folder-row--open { background: rgba(0,194,168,0.14); }\n.dash-folder-iconbox { background: rgba(0,194,168,0.14); color: var(--kq-accent); }\n.dash-folder-name { color: var(--kq-ink); }\n.dash-folder-meta, .dash-folder-chevron { color: var(--kq-muted); }\n\n/* status pills: readable on dark */\n.pill-done { background: rgba(47,190,132,0.16); color: #2FBE84; }\n.pill-wait { background: rgba(244,162,97,0.16); color: #F4A261; }\n.pill-run  { background: rgba(47,185,217,0.16); color: #2FB9D9; }\n\n/* run summary + panels */\n.dash-run-summary,\n.dash-panel { background: var(--kq-card); border-color: var(--kq-line); box-shadow: none; }\n.dash-run-summary { border-left-color: var(--kq-accent); padding: 12px 18px; margin-bottom: 12px; }\n.dash-run-summary-grid { color: var(--kq-ink); }\n.dash-td-label, .dash-panel-title { color: var(--kq-muted); }\n\n/* Customize menu */\n.dash-customize-menu { background: var(--kq-panel); border-color: var(--kq-line); box-shadow: 0 10px 24px rgba(0,0,0,.45); }\n.dash-customize-item { color: var(--kq-ink); }\n.dash-customize-item:hover { background: rgba(0,194,168,0.09); }\n\n/* ─── Profile & settings modal ──────────────────────────── */\n.dash-modal-backdrop { background: rgba(4,12,22,0.70); }\n.dash-modal { background: var(--kq-panel); border: 1px solid var(--kq-line); box-shadow: 0 20px 48px rgba(0,0,0,.55); }\n.dash-modal-title { color: var(--kq-ink); }\n.dash-modal-text { color: var(--kq-muted); }\n.dash-modal-label { color: var(--kq-muted); }\n.dash-modal-input { background: var(--color-input-bg, #0D1F32); border-color: var(--color-input-border, #1F3350); color: var(--kq-ink); font-family: inherit; }\n.dash-modal-input::placeholder { color: #64768A; }\n.dash-modal-input:focus { border-color: var(--kq-accent); box-shadow: 0 0 0 3px rgba(0,194,168,0.18); }\n.dash-modal-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 14px; }\n.dash-modal-row .dash-modal-label { margin: 0; }\n.dash-modal-row--split { margin: 14px 0 0; padding-top: 12px; border-top: 1px solid var(--kq-line); }\n.dash-modal-value { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 600; color: var(--kq-ink); }\n.dash-modal-value i { color: var(--kq-accent); }\n.dash-modal-saved { margin-right: auto; font-size: 12px; font-weight: 600; color: #2FBE84; }\n\n/* ─── Run History + Systems pages share these classes: keep them dark ─── */\n.rh-title { color: var(--kq-ink); }\n.rh-sub { color: var(--kq-muted); }\n.rh-toolbar { background: var(--kq-bg); }\n.rh-filters { background: var(--kq-surface); }\n.rh-filter { color: var(--kq-muted); font-family: inherit; }\n.rh-filter--on { background: var(--kq-panel); color: var(--kq-accent); box-shadow: none; }\n.rh-search { background: var(--color-input-bg, #0D1F32); border-color: var(--color-input-border, #1F3350); color: var(--kq-ink); }\n.rh-search:focus { border-color: var(--kq-accent); }\n.rh-note { color: #F4A261; background: rgba(244,162,97,0.12); }\n.rh-group { background: var(--kq-card); border-color: var(--kq-line); }\n.rh-group-header { background: var(--kq-card); }\n.rh-group-header:hover { background: var(--kq-surface); }\n.rh-group-name { color: var(--kq-ink); }\n.rh-group-body { border-top-color: var(--kq-line); }\n.rh-row--head { color: var(--kq-muted); border-bottom-color: var(--kq-line); }\n.rh-row-wrap:not(:last-child) .rh-row { border-bottom-color: var(--kq-line); }\n.rh-dim { color: var(--color-text-dim, #64768A); }\n.rh-date { color: var(--kq-muted); }\n.rh-action { color: var(--kq-muted); }\n.rh-action:hover { background: rgba(0,194,168,0.10); border-color: rgba(0,194,168,0.35); color: var(--kq-accent); }\n.rh-action--danger:hover { background: rgba(242,85,90,0.14); border-color: rgba(242,85,90,0.4); color: #f2555a; }\n.rh-more { border-color: var(--color-border-light, #2A415F); color: var(--kq-accent); font-family: inherit; }\n.rh-more:hover { background: rgba(0,194,168,0.09); }\n.rh-summary { background: var(--kq-surface); border-left-color: var(--kq-accent); }\n\n@media (max-width: 1100px) { .dash-summary-grid { grid-template-columns: 1fr 1fr; } }\n@media (max-width: 720px) {\n  .dash-summary-grid { grid-template-columns: 1fr; }\n  .dash-page { padding: 14px 12px 28px; --kq-card-h: 280px; }\n  .dash-checklist-head { flex-direction: column; gap: 2px; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .dash-step-link, .dash-metric, .dash-hero-chip { transition: none; }\n}\n\n\n/* Performance tiles: two tiles now that Avg. R² is gone */\n.dash-metric-grid { grid-template-columns: repeat(2, 1fr); }\n\n\n/* First-time view: three placeholder cards (client reference layout) */\n.dash-first-grid { margin-bottom: 12px; }\n.dash-first-card { flex-direction: column; justify-content: center; align-items: center; text-align: center; min-height: 190px; padding: 22px 20px; gap: 12px; }\n.dash-first-icon { font-size: 40px; color: var(--kq-accent); opacity: .85; }\n.dash-first-card .dash-summary-text { max-width: 280px; text-align: center; }\n.dash-step-pending { margin-left: 8px; padding: 1px 8px; border-radius: 10px; font-size: 10.5px; font-weight: 600; line-height: 16px; display: inline-block; text-decoration: none; color: var(--kq-muted); background: rgba(147,169,188,0.16); }\n\n/* ════════════════════════════════════════════════════════════════════════\n   Reports page (/run-history) — row alignment, bigger action icons, and the\n   compact report panel (FitReport.jsx).  Appended last so it wins over the\n   earlier .rh-* rules; colours use the --kq-* tokens so it follows the\n   light / dark theme automatically.\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* ── 1. Row + header columns line up ────────────────────────────────────\n   Every .rh-row is its own grid, so an `auto` last track gave the header\n   row and each data row DIFFERENT widths for the fr columns (Model / R² /\n   Date / Status drifted). The Actions track is now a fixed width, which\n   makes every row's columns identical.\n   5 icons x 36px + 4 gaps x 6px = 204px  ->  208px.                    */\n@media (min-width: 901px) {\n  .rh-row {\n    grid-template-columns: 22px minmax(0, 1.6fr) 1fr 0.7fr 1.1fr 0.9fr 208px;\n  }\n}\n.rh-row--head > span { text-align: left; }\n.rh-row--head > span:last-child { text-align: right; }\n.rh-row .dash-status-pill { justify-self: start; }   /* pill hugs its text, not the column */\n\n/* ── 2. Bigger Actions icons ────────────────────────────────────────── */\n.rh-actions { gap: 6px; }\n.rh-action {\n  width: 36px;\n  height: 36px;\n  font-size: 19px;\n  border-radius: 9px;\n  background: rgba(127, 147, 168, 0.10);\n}\n.rh-action:disabled { opacity: 0.5; cursor: progress; }\n\n/* ── 3. Report panel: compact two-column layout, Downloads on the right ─ */\n.rh-summary { padding: 10px 14px; }\n\n.fr-report { display: flex; flex-direction: column; gap: 10px; }\n\n.fr-head {\n  display: flex;\n  justify-content: space-between;     /* title left, downloads right */\n  align-items: flex-start;\n  gap: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--kq-line);\n}\n.fr-title { margin: 0; font-size: 15px; font-weight: 700; color: var(--kq-ink); }\n.fr-sub   { margin: 2px 0 0; font-size: 12px; color: var(--kq-muted); }\n\n.fr-downloads { display: flex; gap: 8px; flex-shrink: 0; }\n.fr-downloads .fr-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  margin: 0;\n  border: 1px solid var(--kq-line);\n  border-radius: 8px;\n  background: transparent;\n  color: var(--kq-accent);\n  font-family: inherit;\n  font-size: 12.5px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.fr-downloads .fr-btn:hover { background: rgba(0, 194, 168, 0.10); border-color: var(--kq-accent); }\n\n/* Results | Inputs side by side on top; Fitted parameters full width below.\n   (DOM order is Results, Fitted parameters, Inputs — `order` reshuffles it.) */\n.fr-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  align-items: start;\n}\n.fr-grid > .fr-section:nth-child(1) { order: 1; }   /* Results */\n.fr-grid > .fr-section:nth-child(3) { order: 2; }   /* Inputs */\n.fr-grid > .fr-section:nth-child(2) {               /* Fitted parameters */\n  order: 3;\n  grid-column: 1 / -1;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));   /* reactions side by side; a single reaction stretches full width */\n  gap: 8px 10px;\n  align-items: start;\n}\n.fr-grid > .fr-section:nth-child(2) > .fr-section-title,\n.fr-grid > .fr-section:nth-child(2) > .fr-empty { grid-column: 1 / -1; }\n\n.fr-section {\n  padding: 8px 12px 10px;\n  border: 1px solid var(--kq-line);\n  border-radius: 10px;\n  background: var(--kq-card);\n  min-width: 0;\n}\n.fr-section-title {\n  margin: 0 0 6px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--kq-accent);\n}\n.fr-subtitle { margin: 8px 0 3px; font-size: 12px; font-weight: 700; color: var(--kq-ink); }\n.fr-rx {\n  padding: 6px 10px 8px;\n  border: 1px solid var(--kq-line);\n  border-radius: 8px;\n  background: var(--kq-surface);\n  min-width: 0;\n}\n.fr-rx .fr-subtitle { margin-top: 2px; color: var(--kq-accent); }\n\n/* key / value tables: label left, value right, hairline between rows */\n.fr-table { width: 100%; border-collapse: collapse; font-size: 12.5px; }\n.fr-table th,\n.fr-table td { padding: 3px 0; border-bottom: 1px solid var(--kq-line); vertical-align: top; }\n.fr-table tr:last-child th,\n.fr-table tr:last-child td { border-bottom: 0; }\n.fr-table th {\n  text-align: left;\n  font-weight: 500;\n  color: var(--kq-muted);\n  padding-right: 10px;\n}\n.fr-table td {\n  text-align: right;\n  font-weight: 600;\n  color: var(--kq-ink);\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: anywhere;\n}\n\n.fr-empty { margin: 4px 0; font-size: 12.5px; color: var(--kq-muted); }\n.fr-notes { margin: 8px 0 0; font-size: 12.5px; color: var(--kq-ink); }\n\n@media (max-width: 900px) {\n  .fr-grid { grid-template-columns: minmax(0, 1fr); }\n  .fr-head { flex-direction: column; }\n}\n\n/* ── Reaction card: facts flow into as many columns as the width allows ── */\n.fr-kv-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  column-gap: 20px;\n}\n.fr-kv {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 10px;\n  padding: 4px 0;\n  border-bottom: 1px solid var(--kq-line);\n  font-size: 12.5px;\n  min-width: 0;\n}\n.fr-kv-name { color: var(--kq-muted); font-weight: 500; }\n.fr-kv-val {\n  color: var(--kq-ink);\n  font-weight: 600;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: anywhere;\n}\n/* long text (e.g. Aspen-ready dump) gets its own full-width line */\n.fr-kv--wide { grid-column: 1 / -1; flex-direction: column; align-items: flex-start; gap: 2px; }\n.fr-kv--wide .fr-kv-val { text-align: left; font-weight: 500; }\n\n.fr-more {\n  margin-top: 6px;\n  padding: 3px 0;\n  border: 0;\n  background: none;\n  color: var(--kq-accent);\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.fr-more:hover { text-decoration: underline; }\n\n/* ── Use the full width: a single reaction card stretches across the panel ──\n   (kept as its own late rule so it wins even if the earlier\n   `.fr-grid > .fr-section:nth-child(2)` rule still says auto-fill)        */\n.fr-grid > .fr-section:nth-child(2) {\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n}\n.fr-kv-grid { grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); }\n\n/* ── Single reaction: key facts (left) | details incl. Aspen block (right) ──\n   FIX (content overflowed its card): the card used to sit in ONE narrow grid\n   track while its two inner columns needed more than that. It now spans the\n   whole row, and the two columns are a wrapping flex row, so they can never\n   spill outside the card — they sit side by side when there is room and stack\n   when there isn't.                                                          */\n.fr-rx--split {\n  grid-column: 1 / -1;           /* take the full width of the Fitted parameters panel */\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 0 18px;\n}\n.fr-rx--split > .fr-subtitle { flex: 0 0 100%; margin-bottom: 4px; }\n.fr-rx--split > .fr-kv-grid  { flex: 1 1 300px; min-width: 0; }\n.fr-rx--split > .fr-kv-grid:last-child { flex: 1.5 1 340px; }\n.fr-kv-grid--one { grid-template-columns: minmax(0, 1fr); }\n.fr-aspen .fr-kv-val { line-height: 1.45; font-weight: 500; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
